{
	"dialog.ok": "OK",
	"dialog.cancel": "Annuler",
	"dialog.confirm": "Confirmer",
	"dialog.close": "Fermer",
	"dialog.import": "Importer",
	"dialog.save": "Enregistrer",
	"dialog.discard": "Ignorer",
	"dialog.dontshowagain": "Ne plus afficher",
	"data.cube": "Cube",
	"data.group": "Groupe",
	"data.texture": "Texture",
	"data.plugin": "Plugin",
	"data.preview": "Aperçu",
	"data.toolbar": "Barre d'outils",
	"data.image": "Image",
	"keys.ctrl": "Ctrl",
	"keys.shift": "Maj",
	"keys.alt": "Alt",
	"keys.meta": "Cmd",
	"keys.delete": "Suppr",
	"keys.space": "Espace",
	"keys.leftclick": "Clic gauche",
	"keys.middleclick": "Clic molette",
	"keys.rightclick": "Clic droit",
	"keys.tab": "Tabulation",
	"keys.backspace": "Retour arrière",
	"keys.enter": "Entrée",
	"keys.escape": "Échap",
	"keys.function": "F%0",
	"keys.numpad": "Pavé numérique %0",
	"keys.caps": "Verr. maj.",
	"keys.menu": "Menu contextuel",
	"keys.left": "Gauche",
	"keys.up": "Haut",
	"keys.right": "Droite",
	"keys.down": "Bas",
	"keys.pageup": "Page précédente",
	"keys.pagedown": "Page suivante",
	"keys.plus": "Plus",
	"keys.comma": "Virgule",
	"keys.point": "Point",
	"keys.minus": "Moins",
	"keys.cross": "Croix",
	"keys.end": "Fin",
	"keys.pos1": "Pos 1",
	"keys.printscreen": "Impression d'écran",
	"keys.pause": "Pause",
	"message.rotation_limit.title": "Limites de rotation",
	"message.rotation_limit.message": "Minecraft limite les rotations à un axe et par intervalles de 22.5 degrés. Appliquer une rotation sur un axe va réinitialiser la rotation sur les autres axes. Convertissez le modèle en « Modèle libre » si vous modélisez à d'autres fins et avez besoins de rotations libres.",
	"message.file_not_found.title": "Fichier introuvable",
	"message.file_not_found.message": "Blockbench n'a pas pu trouver le fichier demandé. Assurez-vous qu'il est bien stocké localement et non sur un cloud.",
	"message.screenshot.title": "Capture d'écran",
	"message.screenshot.clipboard": "Presse-papier",
	"message.screenshot.right_click": "Clic droit ou appuyez longuement pour copier",
	"message.invalid_file.title": "Fichier invalide",
	"message.invalid_file.message": "Impossible d'ouvrir le fichier json : %0",
	"message.invalid_model.title": "Fichier modèle invalide",
	"message.invalid_model.message": "Le fichier ne contient pas de donnée de modèle valide",
	"message.child_model_only.title": "Modèle fils vide",
	"message.child_model_only.message": "Ce fichier est un fils de %0 et ne contient aucun modèle.",
	"message.unsaved_textures.title": "Textures non sauvegardées",
	"message.unsaved_textures.message": "Votre modèle présente des textures non sauvegardées. Assurez-vous de les enregistrer et de les coller dans le bon dossier de votre pack de ressources.",
	"message.model_clipping.title": "Modèle trop grand",
	"message.model_clipping.message": "Votre modèle contient %0 cubes dépassant la limite de 3×3×3 imposée par Minecraft. Ce modèle ne fonctionnera pas dans Minecraft.",
	"message.loose_texture.title": "Import de texture",
	"message.loose_texture.message": "La texture que vous avez importée ne se trouve pas dans un pack de ressources. Minecraft ne peut charger que des textures appartenant au dossier textures d'un pack de ressources chargé.",
	"message.loose_texture.change": "Changer le chemin",
	"message.update_res.title": "Résolution de la texture",
	"message.update_res.message": "Souhaitez-vous mettre à jour la résolution du projet vers la résolution de cette texture ? Cliquez sur Annuler si votre texture a une plus grande résolution que la normale.",
	"message.update_res.update": "Mise à jour",
	"message.bedrock_overwrite_error.message": "Blockbench ne peut combiner ce modèle avec l'ancien fichier",
	"message.bedrock_overwrite_error.backup_overwrite": "Faire une sauvegarde et écraser",
	"message.bedrock_overwrite_error.overwrite": "Écraser",
	"message.close_warning.message": "Souhaitez-vous enregistrer votre modèle ?",
	"message.close_warning.web": "Toutes données non sauvegardées seront perdues. Voulez-vous vraiment quitter ?",
	"message.default_textures.title": "Textures par défaut",
	"message.default_textures.message": "Sélectionnez le dossier textures du pack de ressources par défaut",
	"message.default_textures.detail": "Extrayez le pack de ressources par défaut de Minecraft à partir du fichier .jar ou depuis Internet et téléchargez-le. Ensuite, localisez le dossier « textures » et ouvrez-le. Blockbench se souviendra de cet emplacement et tentera d'y chercher des textures s'il ne parvient pas à les trouver dans le pack de ressources actuel.",
	"message.default_textures.select": "Sélectionnez un dossier de « textures » par défaut",
	"message.image_editor.title": "Sélectionnez un éditeur d'images",
	"message.image_editor.file": "Sélectionner un fichier...",
	"message.image_editor.exe": "Sélectionnez l'exécutable de l'éditeur d'images",
	"message.display_skin.title": "Skin Minecraft",
	"message.display_skin.message": "Sélectionnez un skin sur votre ordinateur ou entrez un nom de joueur",
	"message.display_skin.upload": "Importer un skin",
	"message.display_skin.reset": "Réinitialiser",
	"message.invalid_plugin": "Plugin invalide, voir console",
	"message.load_plugin_app": "Voulez-vous autoriser ce plugin à apporter des modifications à votre ordinateur ? Ne chargez que des plugins venant de personnes en qui vous avez confiance.",
	"message.load_plugin_web": "Voulez-vous charger ce plugin ? Ne chargez que des plugins venant de personnes en qui vous avez confiance.",
	"message.preset_no_info": "Ce préréglage ne contient pas d'informations pour cet emplacement",
	"message.restart_to_update": "Redémarrez Blockbench pour appliquer les modifications",
	"message.save_file": "Enregistré sous %0",
	"dialog.project.title": "Projet",
	"dialog.project.name": "Nom du fichier",
	"dialog.project.parent": "Modèle parent",
	"dialog.project.geoname": "Identifiant du modèle",
	"dialog.project.ao": "Occlusion ambiante",
	"dialog.texture.title": "Texture",
	"dialog.texture.variable": "Variable",
	"dialog.texture.namespace": "Espace de noms",
	"dialog.texture.folder": "Dossier",
	"dialog.extrude.title": "Extruder l'image",
	"dialog.extrude.mode": "Mode scan",
	"dialog.extrude.mode.areas": "Zones",
	"dialog.extrude.mode.lines": "Lignes",
	"dialog.extrude.mode.columns": "Colonnes",
	"dialog.extrude.mode.pixels": "Pixels",
	"dialog.extrude.opacity": "Opacité minimale",
	"dialog.extrude.scan": "Scanner et importer",
	"dialog.display_preset.title": "Créer un préréglage",
	"dialog.display_preset.message": "Sélectionnez les emplacement que vous voulez enregistrer",
	"dialog.display_preset.create": "Créer",
	"dialog.select.title": "Sélectionner",
	"dialog.select.group": "Dans le groupe sélectionné",
	"dialog.select.name": "Le nom contient",
	"dialog.select.random": "Aléatoire",
	"dialog.select.select": "Sélectionner",
	"dialog.scale.title": "Mise à l'échelle",
	"dialog.scale.axis": "Axe",
	"dialog.scale.clipping": "Avertissement: Votre modèle est trop grand pour le canevas",
	"dialog.scale.confirm": "Mettre à l'échelle",
	"dialog.plugins.title": "Plugins",
	"dialog.plugins.installed": "Installés",
	"dialog.plugins.available": "Disponibles",
	"dialog.plugins.install": "Installer",
	"dialog.plugins.uninstall": "Désinstaller",
	"dialog.plugins.reload": "Actualiser",
	"dialog.plugins.none_installed": "Aucun plugin installé",
	"dialog.plugins.none_available": "Aucun plugin disponible",
	"dialog.plugins.web_only": "Seulement pour l'application en ligne",
	"dialog.plugins.app_only": "Seulement pour l'application de bureau",
	"dialog.plugins.author": "par %0",
	"dialog.create_texture.folder": "Dossier",
	"dialog.create_texture.resolution": "Résolution",
	"dialog.input.title": "Entrée",
	"dialog.settings.settings": "Paramètres",
	"dialog.settings.keybinds": "Raccourcis clavier",
	"dialog.settings.about": "À propos",
	"layout.color.back": "Arrière",
	"layout.color.back.desc": "Arrières-plans et champs de saisie",
	"layout.color.dark": "Sombre",
	"layout.color.dark.desc": "Canevas d'arrière-plan",
	"layout.color.ui": "IU",
	"layout.color.ui.desc": "Couleur principale de l'interface",
	"layout.color.bright_ui": "IU claire",
	"layout.color.bright_ui.desc": "Menus contextuels et info-bulles",
	"layout.color.button": "Bouton",
	"layout.color.button.desc": "Boutons et interrupteurs",
	"layout.color.selected": "Sélectionné",
	"layout.color.selected.desc": "Onglets et objets sélectionnés",
	"layout.color.border": "Bordure",
	"layout.color.border.desc": "Bordure des boutons et entrées",
	"layout.color.accent": "Accent",
	"layout.color.accent.desc": "Curseur et autres détails",
	"layout.color.grid": "Grille",
	"layout.color.grid.desc": "Grille d'aperçu 3D",
	"layout.color.text": "Texte",
	"layout.color.text.desc": "Texte normal",
	"layout.color.light": "Clair",
	"layout.color.light.desc": "Texte sélectionné",
	"layout.color.accent_text": "Texte accentué",
	"layout.color.accent_text.desc": "Texte sur clair ou éléments d'accentuation",
	"layout.font.main": "Police principale",
	"layout.font.headline": "Police de titre",
	"about.version": "Version :",
	"settings.category.general": "Général",
	"settings.category.preview": "Aperçu",
	"settings.category.grid": "Grille",
	"settings.category.edit": "Édition",
	"settings.category.snapping": "Alignement",
	"settings.category.defaults": "Par Défauts",
	"settings.category.dialogs": "Dialogues",
	"settings.category.export": "Exporter",
	"settings.language": "Langue",
	"settings.language.desc": "Langue de l'interface. Redémarrez Blockbench pour appliquer les modifications.",
	"settings.backup_interval": "Intervalle de sauvegarde",
	"settings.backup_interval.desc": "Intervalle des sauvegardes automatiques en minutes",
	"settings.origin_size": "Point de pivot",
	"settings.origin_size.desc": "Taille du point de pivot",
	"settings.control_size": "Axes de contrôle",
	"settings.control_size.desc": "Taille du gizmo de transformation",
	"settings.display_skin": "Affichage skin",
	"settings.display_skin.desc": "Skin utilisé pour le modèle de joueur de référence",
	"settings.shading": "Ombrage",
	"settings.shading.desc": "Activer les ombres dans l'aperçu",
	"settings.base_grid": "Petite grille",
	"settings.base_grid.desc": "Affiche la petite grille et les axes",
	"settings.large_grid": "Grille",
	"settings.large_grid.desc": "Affiche la grille de précision 16×16 (taille d'un bloc)",
	"settings.full_grid": "Grande grille",
	"settings.full_grid.desc": "Étend la grille de précision à la grande zone de 3×3 blocs",
	"settings.large_box": "Grande boîte",
	"settings.large_box.desc": "Affiche les limites de taille",
	"settings.display_grid": "Mode d'affichage",
	"settings.display_grid.desc": "Affiche la grille en mode affichage",
	"settings.undo_limit": "Limite d'annulations",
	"settings.undo_limit.desc": "Nombre d'étapes annulable",
	"settings.local_move": "Déplacer selon les axes relatifs",
	"settings.local_move.desc": "Déplace les éléments à rotation selon leurs propres axes si possible",
	"settings.canvas_unselect": "Désélectionner par clic",
	"settings.canvas_unselect.desc": "Désélectionne tous les éléments en cliquant sur l'arrière-plan du canevas",
	"settings.paint_side_restrict": "Restreint le pinceau sur une face",
	"settings.paint_side_restrict.desc": "Restreint le pinceau pour ne peindre que du côté en cours",
	"settings.autouv": "UV automatiques",
	"settings.autouv.desc": "Active l'UV automatique par défaut",
	"settings.create_rename": "Renommer le nouvel élément",
	"settings.create_rename.desc": "Entrer dans le champ de saisie du nom à la création d'un élément ou d'un groupe",
	"settings.edit_size": "Résolution de la grille",
	"settings.edit_size.desc": "Résolution de la grille de base sur laquelle les cubes s'alignent (s'aimantent)",
	"settings.shift_size": "Résolution shift",
	"settings.shift_size.desc": "Résolution de la grille en maintenant shift",
	"settings.ctrl_size": "Résolution Ctrl",
	"settings.ctrl_size.desc": "Résolution de la grille en maintenant Ctrl",
	"settings.negative_size": "Taille négative",
	"settings.negative_size.desc": "Autorise l'outil d'échelle à utiliser des tailles négatives",
	"settings.minifiedout": "Minimiser l'exportation",
	"settings.minifiedout.desc": "Écrit tout le code du modèle sur une seule ligne",
	"settings.export_groups": "Exporter les groupes",
	"settings.export_groups.desc": "Enregistrer les données des groupes dans les fichiers des modèles",
	"settings.credit": "Crédits",
	"settings.credit.desc": "Ajoute un commentaire de crédit personnalisé aux fichiers exportés",
	"settings.default_path": "Chemin par défaut des textures Minecraft",
	"settings.default_path.desc": "Dossier à partir duquel Blockbench charge les textures par défaut",
	"settings.image_editor": "Éditeur d'images",
	"settings.image_editor.desc": "Éditeur d'images par défaut pour éditer les textures",
	"category.navigate": "Navigation",
	"category.tools": "Outils",
	"category.file": "Fichier",
	"category.blockbench": "Blockbench",
	"category.edit": "Édition",
	"category.transform": "Transformer",
	"category.view": "Vue",
	"category.display": "Paramètres d'affichage",
	"category.textures": "Textures",
	"category.misc": "Divers",
	"keybind.preview_select": "Sélectionner",
	"keybind.preview_rotate": "Rotation d'angle de vue",
	"keybind.preview_drag": "Glissement de vue",
	"keybind.confirm": "Confirmer",
	"keybind.cancel": "Annuler",
	"action.slider_inflate": "Gonfler",
	"action.slider_inflate.desc": "Grossit les cubes dans toutes les directions sans changer les UV",
	"action.slider_brush_size": "Taille",
	"action.slider_brush_size.desc": "Rayon du pinceau en pixels",
	"action.slider_brush_opacity": "Opacité",
	"action.slider_brush_opacity.desc": "Opacité du pinceau en pourcentage",
	"action.slider_brush_softness": "Douceur",
	"action.slider_brush_softness.desc": "Douceur du pinceau en pourcentage",
	"action.uv_slider_pos_x": "Position horizontale",
	"action.uv_slider_pos_x.desc": "Déplace la sélection UV horizontalement pour tous les cubes sélectionnés",
	"action.uv_slider_pos_y": "Position verticale",
	"action.uv_slider_pos_y.desc": "Déplace la sélection UV verticalement pour tous les cubes sélectionnés",
	"action.uv_slider_size_x": "Taille horizontale",
	"action.uv_slider_size_x.desc": "Change la taille horizontale de la sélection UV de tous les cubes sélectionnés",
	"action.uv_slider_size_y": "Taille verticale",
	"action.uv_slider_size_y.desc": "Change la taille verticale de la sélection UV de tous les cubes sélectionnés",
	"action.vertex_snap_mode": "Mode d'alignement",
	"action.vertex_snap_mode.desc": "Choisir si l'alignement (l'aimantation) Vertex doit déplacer les éléments à la position voulue ou les redimentionner",
	"action.move_tool": "Déplacer",
	"action.move_tool.desc": "Outil pour sélectionner et déplacer des éléments",
	"action.resize_tool": "Redimensionner",
	"action.resize_tool.desc": "Outil pour sélectionner et redimensionner des éléments",
	"action.brush_tool": "Pinceau",
	"action.brush_tool.desc": "Pinceau coloré pour dessiner sur des textures",
	"action.vertex_snap_tool": "Alignement Vertex",
	"action.vertex_snap_tool.desc": "Déplace un cube vers un autre en connectant deux sommets",
	"action.swap_tools": "Changer d'outil",
	"action.swap_tools.desc": "Bascule entre les outils de déplacement de redimension",
	"action.project_window": "Projet…",
	"action.project_window.desc": "Ouvre la fenêtre Projet, d'où vous pouvez éditer les métadonnées de votre modèle",
	"action.open_model": "Ouvrir un modèle",
	"action.open_model.desc": "Ouvre un fichier de modèle à partir de votre ordinateur.",
	"action.extrude_texture": "Texture extrudée",
	"action.extrude_texture.desc": "Génère un modèle en étirant une texture",
	"action.export_blockmodel": "Exporter le modèle",
	"action.export_blockmodel.desc": "Exporter le modèle en tant que bloc ou item Java Edition",
	"action.export_optifine_part": "Exporter en partie OptiFine",
	"action.export_optifine_part.desc": "Exporter une partie de modèle d'entité OptiFine",
	"action.export_optifine_full": "Exporter JEM OptiFine",
	"action.export_optifine_full.desc": "Exporter un modèle complet d'entité OptiFine",
	"action.export_obj": "Exporter un modèle OBJ",
	"action.export_obj.desc": "Exporter un modèle OBJ Wavefront pour du rendu (dans des programmes externes)",
	"action.settings_window": "Paramètres…",
	"action.settings_window.desc": "Ouvre la boîte de dialogue des paramètres Blockbench",
	"action.plugins_window": "Plugins…",
	"action.plugins_window.desc": "Ouvrir la fenêtre du magasin de plugins",
	"action.reset_layout": "Réinitialiser la mise en page",
	"action.reset_layout.desc": "Réinitialiser la mise en page aux valeurs par défaut de Blockbench",
	"action.load_plugin": "Charger un plugin à partir d'un fichier",
	"action.load_plugin.desc": "Charge un plugin en important son fichier source",
	"action.reload_plugins": "Recharger les plugins",
	"action.reload_plugins.desc": "Recharger tous les plugins de développement",
	"action.undo": "Annuler",
	"action.undo.desc": "Annule la dernière action effectuée",
	"action.redo": "Rétablir",
	"action.redo.desc": "Rétablit la dernière action annulée",
	"action.copy": "Copier",
	"action.copy.desc": "Copie la sélection actuelle, la face ou les paramètres d'affichage",
	"action.paste": "Coller",
	"action.paste.desc": "Colle la sélection actuelle, la face ou les paramètres d'affichage",
	"action.cut": "Couper",
	"action.cut.desc": "Coupe la sélection actuelle, la face ou les paramètres d'affichage",
	"action.add_cube": "Ajouter un cube",
	"action.add_cube.desc": "Ajoute un nouveau cube",
	"action.add_group": "Ajouter un groupe",
	"action.add_group.desc": "Ajoute un nouveau groupe ou segment",
	"action.outliner_toggle": "Afficher plus d'options",
	"action.outliner_toggle.desc": "Permet d'afficher/masquer des options additionnelles dans la liste",
	"action.duplicate": "Dupliquer",
	"action.delete": "Supprimer",
	"action.sort_outliner": "Trier la liste",
	"action.sort_outliner.desc": "Trie la liste par ordre alphabétique",
	"action.select_window": "Sélectionner…",
	"action.select_window.desc": "Rechercher et sélectionner des éléments en fonction de leurs propriétés",
	"action.invert_selection": "Inverser la sélection",
	"action.invert_selection.desc": "Inverse la sélection des éléments actuelle",
	"action.select_all": "Sélectionner tout",
	"action.collapse_groups": "Détruire les groupes",
	"action.collapse_groups.desc": "Détruit tous les groupes dans la liste",
	"action.scale": "Mettre à l'échelle...",
	"action.scale.desc": "Redimensionne les éléments sélectionnés",
	"action.toggle_visibility": "Changer la visibilité",
	"action.toggle_visibility.desc": "Affiche/masque les éléments sélectionnés",
	"action.toggle_export": "Changer l'exportation",
	"action.toggle_export.desc": "Change le paramètre d'exportation des éléments sélectionnés",
	"action.toggle_autouv": "UV auto/manuel",
	"action.toggle_autouv.desc": "Active/désactive le réglage UV automatique des cubes sélectionnés",
	"action.toggle_shade": "Ombres",
	"action.toggle_shade.desc": "Active/désactive l'ombrage des cubes sélectionnés",
	"action.rename": "Renommer",
	"action.rename.desc": "Change le nom des éléments ou groupes sélectionnés",
	"action.add_display_preset": "Nouveau préréglage",
	"action.add_display_preset.desc": "Ajoute un nouveau paramètre d'affichage prédéfini",
	"action.fullscreen": "Plein écran",
	"action.fullscreen.desc": "Active/désactive le mode plein écran",
	"action.zoom_in": "Zoomer",
	"action.zoom_in.desc": "Effectue un zoom avant pour agrandir l'interface",
	"action.zoom_out": "Dézoomer",
	"action.zoom_out.desc": "Effectue un zoom arrière pour réduire l'interface",
	"action.zoom_reset": "Réinitialiser le zoom",
	"action.zoom_reset.desc": "Réinitialise le niveau de zoom à 100 %",
	"action.reset_interface": "Réinitialiser l'interface",
	"action.reset_interface.desc": "Réinitialise la taille et les positions de l'interface",
	"action.screenshot_model": "Capture d'écran du modèle",
	"action.screenshot_model.desc": "Prend une capture d'écran recadrée du modèle sous l'angle actuel",
	"action.screenshot_app": "Capture d'écran",
	"action.screenshot_app.desc": "Prend une capture d'écran de l'ensemble de l'application",
	"action.import_texture": "Importer une texture",
	"action.import_texture.desc": "Importer une ou plusieurs textures depuis vos fichiers",
	"action.create_texture": "Créer une texture",
	"action.create_texture.desc": "Crée une texture vierge ou une texture de référence",
	"action.save_textures": "Enregistrer les textures",
	"action.save_textures.desc": "Sauvegarde toutes les textures non sauvegardées",
	"action.animated_textures": "Lire les animations de texture",
	"action.animated_textures.desc": "Lecture/pause des textures animées",
	"action.origin_to_geometry": "Centrer le point de pivot",
	"action.origin_to_geometry.desc": "Place le point de pivot au centre de la sélection",
	"action.bone_reset_toggle": "Réinitialiser le segment",
	"action.bone_reset_toggle.desc": "Empêche le segment d'afficher les cubes du modèle parent",
	"action.reload": "Recharger Blockbench",
	"action.reload.desc": "Recharge Blockbench. Toutes données non sauvegardées seront perdues.",
	"menu.file": "Fichier",
	"menu.edit": "Édition",
	"menu.transform": "Transformer",
	"menu.display": "Affichage",
	"menu.view": "Vue",
	"menu.file.new": "Nouveau",
	"menu.file.recent": "Récent",
	"menu.file.import": "Importer",
	"menu.file.export": "Exporter",
	"menu.transform.rotate": "Rotation",
	"menu.transform.flip": "Retourner",
	"menu.transform.center": "Centrer",
	"menu.transform.properties": "Propriétés",
	"menu.display.preset": "Appliquer le préréglage",
	"menu.display.preset_all": "Appliquer le préréglage partout",
	"menu.display.remove_preset": "Supprimer le préréglage",
	"menu.view.zoom": "Zoom",
	"menu.view.background": "Arrière-plan",
	"menu.view.screenshot": "Capture d'écran",
	"menu.cube.color": "Couleur du marqueur",
	"menu.cube.texture": "Texture",
	"menu.cube.texture.transparent": "Transparant",
	"menu.cube.texture.blank": "Vierge",
	"menu.group.sort": "Trier",
	"menu.texture.face": "Appliquer à la face",
	"menu.texture.file": "Fichier",
	"menu.texture.refresh": "Actualiser",
	"menu.texture.change": "Changer de fichier",
	"menu.texture.folder": "Ouvrir dans l'explorateur de fichiers",
	"menu.texture.edit": "Modifier",
	"menu.texture.export": "Enregistrer sous",
	"menu.texture.save": "Enregistrer",
	"menu.texture.properties": "Propriétés…",
	"menu.preview.background": "Arrière-plan",
	"menu.preview.background.load": "Charger",
	"menu.preview.background.position": "Position",
	"menu.preview.background.lock": "Verrouiller à la caméra",
	"menu.preview.screenshot": "Capture d'écran",
	"menu.preview.perspective": "Perspective",
	"menu.preview.perspective.normal": "Normal",
	"menu.preview.quadview": "Affichage quadruple",
	"menu.preview.stop_drag": "Arrêter le positionnement en arrière-plan",
	"menu.uv.mapping.rotation": "Rotation",
	"menu.uv.texture": "Texture",
	"cube.color.light_blue": "Bleu clair",
	"cube.color.yellow": "Jaune",
	"cube.color.orange": "Orange",
	"cube.color.red": "Rouge",
	"cube.color.purple": "Violet",
	"cube.color.blue": "Bleu",
	"cube.color.green": "Vert",
	"cube.color.lime": "Vert clair",
	"switches.visibility": "Visibilité",
	"switches.export": "Exporter",
	"switches.autouv": "UV automatique",
	"panel.uv": "UV",
	"panel.display": "Affichage",
	"panel.textures": "Textures",
	"panel.outliner": "Éléments",
	"uv_editor.title": "Éditeur UV",
	"uv_editor.all_faces": "Toutes",
	"uv_editor.no_faces": "Aucune",
	"face.north": "Nord",
	"face.south": "Sud",
	"face.west": "Ouest",
	"face.east": "Est",
	"face.up": "Haut",
	"face.down": "Bas",
	"direction.north": "Nord",
	"direction.south": "Sud",
	"direction.west": "Ouest",
	"direction.east": "Est",
	"direction.top": "Haut",
	"direction.bottom": "Bas",
	"display.slot.third_right": "3ᵉ personne droite",
	"display.slot.third_left": "3ᵉ personne gauche",
	"display.slot.first_right": "1ʳᵉ personne droite",
	"display.slot.first_left": "1ʳᵉ personne gauche",
	"display.slot.head": "Tête",
	"display.slot.ground": "Sol",
	"display.slot.frame": "Cadre",
	"display.slot.gui": "GUI",
	"display.rotation": "Rotation",
	"display.translation": "Traduction",
	"display.scale": "Taille",
	"display.slot": "Emplacement",
	"display.reference": "Modèle de référence",
	"display.reference.player": "Joueur",
	"display.reference.zombie": "Zombie",
	"display.reference.armor_stand": "Porte-armure",
	"display.reference.baby_zombie": "Bébé zombie",
	"display.reference.armor_stand_small": "Petit porte-armure",
	"display.reference.monitor": "Normal",
	"display.reference.bow": "Arc",
	"display.reference.block": "Bloc",
	"display.reference.frame": "Cadre",
	"display.reference.inventory_nine": "3×3",
	"display.reference.inventory_full": "Inventaire",
	"display.reference.hud": "HUD",
	"display.preset.blank_name": "Veuillez entrer un nom",
	"display.preset.item": "Item par défaut",
	"display.preset.block": "Bloc par défaut",
	"display.preset.handheld": "Arme par défaut",
	"display.preset.rod": "Bâton par défaut",
	"dialog.continue": "Continuer",
	"message.square_textures": "Les textures doivent être carrées",
	"message.unsaved_texture.title": "Texture non sauvegardée",
	"message.unsaved_texture.message": "Toute les modification non enregistrée de cette texture sera perdue. Voulez-vous poursuivre ?",
	"action.vertex_snap_mode.move": "Déplacer",
	"action.vertex_snap_mode.scale": "Redimensionner",
	"action.open_model_folder": "Ouvrir le dossier du modèle",
	"action.open_model_folder.desc": "Ouvre le dossier dans lequel se trouve le modèle",
	"action.change_textures_folder": "Changer l'emplacement des textures",
	"action.change_textures_folder.desc": "Changer le dossier dans lequel toutes les textures sont enregistrées",
	"menu.texture.particle": "Utiliser pour les particules",
	"message.update_notification.title": "Impossible d'installer la mise à jour",
	"message.update_notification.message": "Une nouvelle version de Blockbench est disponible. Veuillez activer les mises à jour automatiques dans les paramètres pour effectuer la mise à jour !",
	"message.untextured": "Cette surface n'a pas de texture",
	"dialog.toolbar_edit.title": "Personnaliser la barre d'outils",
	"keybindings.reset": "Réinitialiser",
	"keybindings.clear": "Vide",
	"action.cube_counter": "Compteur de cube",
	"action.uv_rotation": "Rotation UV",
	"action.uv_rotation.desc": "Rotation de la face UV",
	"action.uv_grid": "Grille UV",
	"action.uv_grid.desc": "La résolution de la grille sur laquelle le sélecteur UV s'aligne",
	"action.uv_grid.auto": "Auto",
	"action.uv_maximize": "Maximiser les UV",
	"action.uv_maximize.desc": "Règle les UV de cette face pour prendre la texture entière",
	"action.uv_auto": "UV auto",
	"action.uv_auto.desc": "Règle les UV de cette face à sa taille réelle",
	"action.uv_rel_auto": "UV auto relatifs",
	"action.uv_rel_auto.desc": "Règle les UV de cette face sa taille et sa position réelles",
	"action.uv_mirror_x": "Miroir UV X",
	"action.uv_mirror_x.desc": "Reflète les UV de cette face selon l'axe X",
	"action.uv_mirror_y": "Miroir UV Y",
	"action.uv_mirror_y.desc": "Reflète les UV de cette face selon l'axe Y",
	"action.uv_transparent": "Face transparente",
	"action.uv_transparent.desc": "Rend la face actuelle transparente",
	"action.uv_reset": "Réinitialiser la face",
	"action.uv_reset.desc": "Réinitialise la face actuelle",
	"action.cullface": "Cullface",
	"action.cullface.desc": "Désactive le rendu de cette face si le côté en question du modèle est couvert",
	"action.auto_cullface": "Cullface automatique",
	"action.auto_cullface.desc": "Définit la cullface de cette face à elle-même",
	"action.face_tint": "Teinte",
	"action.face_tint.desc": "Active l'option de teinte pour la face actuelle",
	"menu.toolbar.edit": "Personnaliser",
	"menu.toolbar.reset": "Réinitialiser",
	"uv_editor.rotated": "Tourné",
	"uv_editor.auto_cull": "Cullface à soi-même",
	"uv_editor.copied": "Face copiée",
	"uv_editor.pasted": "Face collée",
	"uv_editor.copied_x": "%0 faces copiées",
	"uv_editor.reset": "Face réinitialisée",
	"uv_editor.maximized": "Maximisé",
	"uv_editor.autouv": "Taille automatique",
	"uv_editor.mirrored": "Miroir",
	"uv_editor.to_all": "Appliqué à toutes les faces",
	"uv_editor.transparent": "Rendue transparente",
	"uv_editor.cullface_on": "Cullface activée",
	"uv_editor.cullface_off": "Cullface désativée",
	"uv_editor.tint_on": "Teinte activée",
	"uv_editor.tint_off": "Teinte désactivée",
	"action.uv_apply_all": "Appliquer à toutes les faces",
	"action.uv_apply_all.desc": "Applique les paramètres de la face actuelle à toutes les faces",
	"message.image_editor_missing.title": "Éditeur d'images par défaut",
	"message.image_editor_missing.message": "Sélectionnez le fichier exécutable de votre éditeur d'image.",
	"message.image_editor_missing.detail": "Blockbench n'a pas pu trouver d'éditeur d'images sur votre ordinateur. Sélectionnez le fichier exécutable de l'éditeur d'images que vous utilisez.",
	"action.update_autouv": "Mettre à jour l'UV automatique",
	"action.update_autouv.desc": "Met à jour la cartographie UV automatique des cubes sélectionnés",
	"category.uv": "UV",
	"status_bar.saved": "Le modèle est enregistré",
	"status_bar.unsaved": "Il y a des modifications non enregistrées",
	"action.move_up": "Déplacer vers le haut",
	"action.move_up.desc": "Déplace les cubes sélectionnés vers le haut par rapport à l'angle de caméra actuel",
	"action.move_down": "Déplacer vers le bas",
	"action.move_down.desc": "Déplace les cubes sélectionnés vers le bas par rapport à l'angle de caméra actuel",
	"action.move_left": "Déplacer vers la gauche",
	"action.move_left.desc": "Déplace les cubes sélectionnés vers la gauche par rapport à l'angle de caméra actuel",
	"action.move_right": "Déplacer vers la droite",
	"action.move_right.desc": "Déplace les cubes sélectionnés vers la droite par rapport à l'angle de caméra actuel",
	"action.move_forth": "Déplacer vers l'avant",
	"action.move_forth.desc": "Déplace les cubes sélectionnés vers l'avant par rapport à l'angle de la caméra actuelle",
	"action.move_back": "Déplacer vers l'arrière",
	"action.move_back.desc": "Déplace les cubes sélectionnés vers l'arrière par rapport à l'angle de la caméra actuel",
	"layout.color.wireframe": "Squelette",
	"layout.color.wireframe.desc": "Contours de vue squelettique",
	"layout.color.wireframe_selectable": "Squelette sélectionnable",
	"layout.color.wireframe_selectable.desc": "Arêtes et sommets non sélectionnés du maillage actif en mode édition",
	"action.add_animation": "Ajouter une animation",
	"action.add_animation.desc": "Crée une animation vierge",
	"action.load_animation_file": "Importer une animation",
	"action.load_animation_file.desc": "Importer un fichier d'animation",
	"action.play_animation": "Jouer l'animation",
	"action.play_animation.desc": "Aperçu de l'animation sélectionnée",
	"action.slider_keyframe_time": "Code temporel",
	"action.slider_keyframe_time.desc": "Modifie le code temporel des images clés sélectionnées",
	"timeline.rotation": "Rotation",
	"timeline.position": "Position",
	"timeline.scale": "Taille",
	"menu.keyframe.quaternion": "Quaternion",
	"panel.animations": "Animations",
	"panel.keyframe": "Image clé",
	"panel.keyframe.type": "Image clé (%0)",
	"generic.delete": "Supprimer",
	"generic.rename": "Renommer",
	"message.no_animation_selected": "Vous devez sélectionner une animation pour faire cela",
	"message.no_bone_selected": "Vous devez sélectionner un segment pour faire cela",
	"message.duplicate_groups.title": "Dupliquer le nom du segment",
	"message.duplicate_groups.message": "Le nom de ce segment existe sur d'autres segments. Cela peut poser des problèmes.",
	"action.delete_keyframes": "Supprimer images clés",
	"action.delete_keyframes.desc": "Supprime toutes les images clés sélectionnées",
	"menu.animation": "Animation",
	"menu.animation.loop": "Boucle",
	"menu.animation.override": "Outrepasser",
	"menu.animation.anim_time_update": "Mettre la variable à jour",
	"message.display_skin_model.title": "Modèle de skin",
	"message.display_skin_model.message": "Choisissez le type de votre skin",
	"message.display_skin_model.classic": "Classique",
	"message.display_skin_model.slim": "Mince",
	"message.bone_material": "Changer le matériau d'un segment",
	"action.slider_animation_length": "Longueur de l'animation",
	"action.slider_animation_length.desc": "Change la longueur de l'animation selectionnée",
	"panel.variable_placeholders": "Espaces de variables",
	"panel.variable_placeholders.info": "Lister les variables à prévisualiser par nom=valeur",
	"status_bar.vertex_distance": "Distance : %0",
	"dialog.create_gif.title": "Enregistrer un GIF",
	"dialog.create_gif.length": "Durée",
	"dialog.create_gif.fps": "FPS",
	"dialog.create_gif.play": "Démarrer l'animation",
	"category.animation": "Animation",
	"action.record_model_gif": "Enregistrer un GIF...",
	"action.record_model_gif.desc": "Enregistre un GIF animé du modèle à partir de l'angle actuel",
	"display.mirror": "Miroir",
	"data.separator": "Séparateur",
	"menu.preview.background.set_position": "Définir la position",
	"dialog.toolbar_edit.hidden": "Caché",
	"action.export_class_entity": "Exporter une entité Java",
	"action.export_class_entity.desc": "Exporter le modèle d'entité en tant que classe Java",
	"settings.seethrough_outline": "Contours rayons X",
	"settings.seethrough_outline.desc": "Affiche les contours à travers des objets",
	"mode.edit": "Édition",
	"mode.paint": "Dessin",
	"mode.display": "Affichage",
	"mode.animate": "Animer",
	"status_bar.recording_gif": "GIF en cours d'enregistrement",
	"status_bar.processing_gif": "GIF en cours de traitement",
	"settings.backup_retain": "Durée de conservation d'une sauvegarde",
	"settings.backup_retain.desc": "Définir la durée (en jours) pendant laquelle Blockbench conserve les anciennes sauvegardes",
	"action.rotate_tool": "Rotation",
	"action.rotate_tool.desc": "Outil pour sélectionner et faire tourner des éléments",
	"action.fill_tool": "Pot de peinture",
	"action.fill_tool.desc": "Pot de peinture pour remplir des faces entières d'une couleur unie",
	"action.eraser": "Gomme",
	"action.eraser.desc": "Gomme pour remplacer les couleurs d'une texture par de la transparence",
	"action.color_picker": "Pipette",
	"action.color_picker.desc": "Outil pour choisir la couleur des pixels sur votre texture",
	"switches.mirror": "Miroir UV",
	"language_name": "Français",
	"message.plugin_reload": "%0 plugins locaux rechargés",
	"settings.brightness": "Luminosité",
	"settings.brightness.desc": "Luminosité de l'aperçu. La valeur par défaut est 50.",
	"menu.preview.perspective.reset": "Réinitialiser la camera",
	"action.fill_mode": "Mode de remplissage",
	"action.fill_mode.face": "Face",
	"action.fill_mode.color": "Couleur",
	"action.toggle_mirror_uv": "Miroir UV",
	"action.toggle_mirror_uv.desc": "Active/désactive la réflexion UV selon l'axe X des cubes sélectionnés.",
	"menu.texture.blank": "Appliquer aux faces non texturées",
	"dialog.scale.select_overflow": "Sélectionner le débordement",
	"action.action_control": "Contrôle d'action",
	"action.action_control.desc": "Rechercher et exécuter toute action disponible",
	"keybindings.recording": "Enregistrer un raccourci clavier",
	"keybindings.press": "Appuyez sur une touche ou une combinaison de touches ou cliquez n'importe où pour commencer à enregistrer votre raccourci clavier.",
	"action.pivot_tool": "Outil point de pivot",
	"action.pivot_tool.desc": "Outil pour changer le point de pivot des cubes et segments",
	"action.slider_animation_speed": "Vitesse de lecture",
	"action.slider_animation_speed.desc": "Vitesse de lecture de la chronologie en pourcentage",
	"action.previous_keyframe": "Image clé précédente",
	"action.previous_keyframe.desc": "Retourne à l'image clé précédente",
	"action.next_keyframe": "Image clé suivante",
	"action.next_keyframe.desc": "Passe à l'image clé suivante",
	"message.outdated_client.title": "Client obsolète",
	"message.outdated_client.message": "Veuillez effectuer la mise à jour vers la dernière version de Blockbench.",
	"action.export_asset_archive": "Télécharger l'archive",
	"action.export_asset_archive.desc": "Télécharge une archive avec le modèle et toutes les textures qu'elle contient",
	"action.upload_sketchfab": "Mettre en ligne sur Sketchfab",
	"message.sketchfab.name_or_token": "Veuillez entrer votre jeton Sketchfab et un nom",
	"dialog.sketchfab_uploader.title": "Uploader un modèle Sketchfab",
	"dialog.sketchfab_uploader.token": "Jeton d'API",
	"dialog.sketchfab_uploader.about_token": "Le jeton est utilisé pour connecter Blockbench à votre compte Sketchfab. Vous pouvez le trouver sur %0.",
	"dialog.sketchfab_uploader.name": "Nom du modèle",
	"dialog.sketchfab_uploader.description": "Description",
	"dialog.sketchfab_uploader.tags": "Tags",
	"settings.sketchfab_token": "Jeton Sketchfab",
	"settings.sketchfab_token.desc": "Jeton autorisant Blockbench à uploader sur votre compte Sketchfab",
	"panel.color": "Couleur",
	"data.origin": "Point de pivot",
	"message.sketchfab.success": "Modèle mis en ligne avec succès",
	"message.sketchfab.error": "Échec de la mise en ligne du modèle sur Sketchfab",
	"settings.outliner_colors": "Couleurs de la liste",
	"settings.outliner_colors.desc": "Affiche les couleurs des éléments dans la liste",
	"action.upload_sketchfab.desc": "Mettre en ligne votre modèle sur Sketchfab",
	"action.element_colors": "Couleurs du cube",
	"action.element_colors.desc": "Montre les couleurs du cube dans la liste",
	"texture.error.file": "Fichier introuvable",
	"texture.error.parent": "Texture fournie par le modèle parent",
	"message.recover_backup.title": "Récupérer le modèle",
	"message.recover_backup.message": "Blockbench a été fermé sans sauvegarder. Souhaitez-vous récupérer le modèle ?",
	"message.invalid_session.title": "Jeton de session invalide",
	"message.invalid_session.message": "La session que vous essayez de rejoindre a expiré ou le jeton fourni n'est pas valide.",
	"dialog.create_texture.power": "Taille au carré",
	"dialog.create_gif.turn": "Vitesse de rotation",
	"action.edit_session": "Éditer la session…",
	"action.edit_session.desc": "Connectez-vous à une session de travail pour collaborer avec d'autres utilisateurs",
	"action.reset_keyframe": "Réinitialiser image clé",
	"action.reset_keyframe.desc": "Réinitialise toutes les valeurs des images clés sélectionnées",
	"dialog.edit_session.title": "Éditer la session",
	"edit_session.username": "Pseudo",
	"edit_session.token": "Jeton",
	"edit_session.about": "Les sessions de travail peuvent être utilisées pour collaborer sur des modèles sur Internet. Créez une session, copiez le jeton et envoyez-le à des amis, qui peuvent ensuite l'utiliser pour rejoindre.",
	"edit_session.join": "Rejoindre la session",
	"edit_session.create": "Créer une session",
	"edit_session.quit": "Quitter la session",
	"edit_session.joined": "%0 a rejoint la session",
	"edit_session.left": "%0 a quitté la session",
	"edit_session.quit_session": "Quitter la session actuelle",
	"edit_session.status": "Statut",
	"edit_session.hosting": "Hébergement",
	"edit_session.connected": "Connecté à une session",
	"dialog.sketchfab_uploader.private": "Privé (pro)",
	"dialog.sketchfab_uploader.password": "Mot de passe (pro)",
	"action.uv_select_all": "Sélectionner tout",
	"action.uv_select_all.desc": "Sélectionne toutes les faces dans la boîte de dialogue UV",
	"panel.chat": "Chat",
	"edit_session.welcome": "Bienvenue dans la session de %0",
	"dialog.yes": "Oui",
	"dialog.no": "Non",
	"generic.remove": "Retirer",
	"generic.download": "Télécharger",
	"generic.search": "Rechercher",
	"dates.today": "Aujourd'hui",
	"dates.yesterday": "Hier",
	"dates.this_week": "Cette semaine",
	"dates.weeks_ago": "Il y a %0 semaines",
	"mode.start.new": "Nouveau",
	"mode.start.recent": "Récent",
	"format.free": "Modèle libre",
	"format.free.desc": "Modèle sans restrictions. Pour les moteurs de jeux, faire des rendus etc.",
	"format.java_block": "Bloc/Objet Java Edition",
	"format.java_block.desc": "Modèle de bloc ou d'objet pour Java Edition.",
	"format.bedrock": "Entité Bedrock",
	"format.bedrock.desc": "Modèle Minecraft Bedrock Edition pour les entités et les objets joints",
	"format.bedrock_old": "Ancien modèle Bedrock",
	"format.bedrock_old.desc": "Modèle d'entité Bedrock antérieur à la 1.12",
	"format.modded_entity": "Entité moddée",
	"format.modded_entity.desc": "Modèle d'entité pour mods. Peut être exporté sous forme de fichier de classe .java.",
	"format.optifine_entity": "Entité OptiFine",
	"format.optifine_entity.desc": "Modèle d'entité personnalisé pour OptiFine.",
	"keys.mouse": "Bouton de la souris %0",
	"message.cleared_blank_faces.title": "Faces vierges",
	"message.cleared_blank_faces.message": "Blockbench a trouvé %0 cubes sans texture. Voulez-vous retirer ces éléments ?",
	"message.wireframe.enabled": "Vue squelettique activée",
	"message.wireframe.disabled": "Vue squelettique désactivée",
	"dialog.convert_project.title": "Convertir le projet",
	"dialog.create_texture.double_use": "Conserver l'occupation de textures multiples",
	"dialog.model_stats.title": "Statistiques du modèle",
	"dialog.model_stats.cubes": "Cubes",
	"dialog.model_stats.locators": "Localisateurs",
	"dialog.model_stats.groups": "Groupes",
	"dialog.model_stats.vertices": "Sommets",
	"dialog.model_stats.faces": "Faces",
	"settings.username": "Pseudo",
	"settings.username.desc": "Pseudo pour les sessions de travail",
	"settings.painting_grid": "Grille de peinture",
	"settings.painting_grid.desc": "Affiche la grille sur les cubes texturés en mode peinture",
	"action.convert_project": "Convertir le projet",
	"action.convert_project.desc": "Convertit le projet en cours en un projet pour un autre format de modèle",
	"action.close_project": "Fermer le projet",
	"action.close_project.desc": "Ferme le projet actuel",
	"action.export_bedrock": "Exporter la geométrie Bedrock",
	"action.export_bedrock.desc": "Exporter le modèle sous forme de fichier de géométrie Bedrock Edition.",
	"action.save_project": "Enregistrer le projet",
	"action.save_project.desc": "Enregistre le modèle actuel en tant que fichier de projet",
	"action.save_project_as": "Enregistrer le projet sous",
	"action.save_project_as.desc": "Enregistre le modèle actuel en tant que fichier de projet à un nouvel emplacement",
	"action.export_over": "Enregistrer le modèle",
	"action.export_over.desc": "Enregistre le modèle, les textures et les animations en écrasant les fichiers",
	"action.add_locator": "Ajouter un localisateur",
	"action.add_locator.desc": "Ajoute un nouveau localisateur pour contrôler la position des particules, des laisses, etc.",
	"action.uv_turn_mapping": "Tourner cartographie",
	"action.uv_turn_mapping.desc": "Fait pivoter la cartographie UV de 90 degrés",
	"action.remove_blank_faces": "Retirer les faces vierges",
	"action.remove_blank_faces.desc": "Supprime toutes les faces non texturées de la sélection",
	"web.download_app": "Télécharger le logiciel",
	"uv_editor.turned": "Cartographie UV tournée",
	"display.reference.crossbow": "Arbalète",
	"dialog.settings.search_results": "Résultats de recherche",
	"settings.animation_snap": "Aligner les animations",
	"settings.animation_snap.desc": "Intervalle d'aimantation des images clés dans la timeline d'animation en étapes par seconde. Ceci peut aussi se régler pour une animation particulière. La valeur par défaut est 24.",
	"action.import_optifine_part": "Importer partie OptiFine",
	"action.import_optifine_part.desc": "Importer une partie d'entité pour un modèle OptiFine",
	"data.locator": "Localisateur",
	"mode.start.no_recents": "Aucun modèle ouvert récemment",
	"panel.element": "Élément",
	"panel.element.position": "Position",
	"panel.element.size": "Taille",
	"panel.element.origin": "Point de pivot",
	"panel.element.rotation": "Rotation",
	"message.canvas_limit_error.title": "Erreur de limite du canevas",
	"message.canvas_limit_error.message": "L'action n'a pu être effectuée correctement car le format limite le canevas à 48 unités. Décalez le point de pivot pour empêcher cela.",
	"data.effect": "Effet",
	"generic.name": "Nom",
	"settings.recent_projects": "Limite de modèles récents",
	"settings.recent_projects.desc": "Nombre maximal de modèles récents à garder en mémoire",
	"settings.volume": "Volume",
	"settings.volume.desc": "Contrôle du volume pour les effets sonores des animations",
	"action.clear_timeline": "Vider la timeline",
	"action.clear_timeline.desc": "Efface tous les segments non sélectionnés de la timeline",
	"action.select_effect_animator": "Effets et animation",
	"action.select_effect_animator.desc": "Ouvre la timeline pour ajouter du son et des particules",
	"action.timeline_focus": "Canal",
	"action.timeline_focus.desc": "Sélectionner les canaux d'animation à afficher dans la timeline",
	"timeline.particle": "Particule",
	"timeline.sound": "Son",
	"timeline.effects": "Effets",
	"data.format": "Format",
	"format.optifine_part": "Partie OptiFine",
	"format.optifine_part.desc": "Partie JPM pour modèle d'entité OptiFine.",
	"action.reverse_keyframes": "Inverser images clés",
	"action.reverse_keyframes.desc": "Renverse l'ordre des images clés sélectionnées",
	"generic.help": "Aide",
	"message.removed_faces": "%0 faces retirées",
	"dialog.sketchfab_uploader.draft": "Brouillon",
	"action.slider_pos": "Déplacement de %0",
	"action.slider_pos.desc": "Déplacer selon l'axe %0",
	"action.slider_size": "Taille à %0",
	"action.slider_size.desc": "Redimensionner sur l'axe %0",
	"action.slider_rotation": "Rotation de %0",
	"action.slider_rotation.desc": "Tourner selon l'axe %0",
	"action.slider_origin": "Point de pivot %0",
	"action.slider_origin.desc": "Déplace le pivot selon l'axe %0",
	"action.rotate_cw": "Rotation %0 +90",
	"action.rotate_cw.desc": "Fait tourner de 90° autour de l'axe %0 (horaire)",
	"action.rotate_ccw": "Rotation %0 -90",
	"action.rotate_ccw.desc": "Fait tourner de 90° autour de l'axe %0 (anti-horaire)",
	"action.flip": "Retourner %0",
	"action.flip.desc": "Retourne la sélection selon l'axe %0",
	"action.center": "Centrer %0",
	"action.center.desc": "Centre la sélection sur l'axe %0",
	"action.bring_up_all_animations": "Combine toute les animations modifiées sur la timeline",
	"panel.bone": "Segment",
	"data.color": "Couleur",
	"generic.export": "Exporter",
	"generic.none": "Néant",
	"status_bar.recording": "Enregistrement en cours",
	"message.add_to_palette": "Ajouté à la palette",
	"message.size_modifiers": "Maintenir Ctrl ou Maj pour de plus petits incréments.",
	"message.timelapse_start": "Timelapse démarré",
	"message.timelapse_stop": "Timelapse arrêté",
	"message.import_palette.replace_palette": "Remplacer l'ancienne palette",
	"message.import_palette.threshold": "Seuil de fusion",
	"dialog.timelapse.interval": "Intervalle (en secondes)",
	"dialog.timelapse.source": "Source",
	"dialog.timelapse.source.interface": "Interface",
	"dialog.timelapse.source.locked": "Angle verrouillé",
	"dialog.timelapse.destination": "Dossier de destination",
	"layout.color.checkerboard": "Damier",
	"layout.color.checkerboard.desc": "Arrière-plan du canevas et de l'éditeur UV",
	"layout.font.code": "Code police",
	"layout.css": "CSS personnalisé",
	"settings.category.paint": "Peinture",
	"settings.deactivate_size_limit": "Pas de limite de taille",
	"settings.deactivate_size_limit.desc": "Lève les restrictions de taille pour certains formats. ATTENTION : Cela peut rendre des modèles invalides.",
	"settings.brush_opacity_modifier": "Modificateur d'opacité",
	"settings.brush_opacity_modifier.desc": "Modifie l'opacité du pinceau avec un stylet",
	"settings.brush_size_modifier": "Modificateur de taille",
	"settings.brush_size_modifier.desc": "Modifie la taille du pinceau avec un stylet",
	"settings.brush_modifier.pressure": "Pression",
	"settings.brush_modifier.tilt": "Inclinaison",
	"category.color": "Couleur",
	"action.import_theme": "Importer un thème",
	"action.export_theme": "Exporter le thème",
	"action.export_theme.desc": "Crée un fichier thème basé sur les paramètres actuels",
	"action.slider_color_h": "Teinte",
	"action.slider_color_s": "Saturation",
	"action.slider_color_v": "Valeur",
	"action.add_to_palette": "Ajouter à la palette",
	"action.add_to_palette.desc": "Ajoute la couleur sélectionnée à la palette",
	"action.import_palette": "Importer la palette",
	"action.import_palette.desc": "Importer un fichier palette",
	"action.export_palette": "Exporter la palette",
	"action.export_palette.desc": "Exporter en tant que fichier .GPL",
	"action.generate_palette": "Générer une palette",
	"action.generate_palette.desc": "Génère une palette à partir d'une texture",
	"action.sort_palette": "Trier palette",
	"action.sort_palette.desc": "Trie toutes les couleurs par teinte et luminosité",
	"action.timelapse": "Timelapse…",
	"action.timelapse.desc": "Enregistrer un timelapse de la modélisation",
	"action.add_keyframe": "Ajouter image clé",
	"action.add_keyframe.desc": "Ajoute une keyframe automatiquement. Appuyez sur Maj pour forcer les valeurs par défaut.",
	"action.bring_up_all_animations.desc": "Met toutes les animations modifiés dans la timeline",
	"timeline.timeline": "Instructions",
	"menu.palette.load.default": "Par défaut",
	"generic.import": "Importer",
	"settings.brush_modifier.none": "Aucun(e)",
	"action.export_entity": "Exporter entité Bedrock",
	"action.export_entity.desc": "Ajoute le modèle actuel comment entité à un fichier mobs.json",
	"settings.highlight_cubes": "Surligner cubes",
	"settings.highlight_cubes.desc": "Surligne les cubes que vous survolez ou sélectionnez",
	"action.add_marker": "Définir un repère",
	"action.add_marker.desc": "Définir un repère chronologique",
	"timeline.pre_effect_script": "Script",
	"format.skin": "Skin Minecraft",
	"format.skin.desc": "Modifie les skins de joueurs et d'entités.",
	"message.sketchfab.setup_guide": "Vous voulez apprendre comment mettre en place des modèles sur Sketchfab ? Lire %0",
	"dialog.skin.title": "Créer un skin",
	"dialog.skin.model": "Skin",
	"action.toggle_skin_layer": "Alterner la couche du skin",
	"action.toggle_skin_layer.desc": "Affiche/masque la couche externe du modèle de skin",
	"action.gui_light": "Lumière dans la GUI",
	"action.gui_light.desc": "Sélectionner la façon dont l'item est éclairé dans l'inventaire",
	"action.gui_light.side": "Lumière latérale",
	"action.gui_light.front": "Lumière frontale",
	"action.move_keyframe_back": "Images clés en arrière",
	"action.move_keyframe_forth": "Images clés en avant",
	"menu.help": "Aide",
	"menu.help.discord": "Serveur Discord",
	"menu.help.report_issue": "Rapporter un bug",
	"menu.help.plugin_documentation": "Documentation de l'API du plugin",
	"menu.help.search_action": "Chercher et exécuter une action",
	"menu.help.donate": "Faire un dons",
	"menu.help.about": "A propos",
	"menu.preview.background.clipboard": "Charger depuis le presse-papier",
	"dialog.ignore": "Ignorer",
	"generic.unset": "Non défini",
	"message.invalid_builtin_parent.title": "Parent intégré invalide",
	"message.invalid_builtin_parent.message": "Le lien vers le modèle parent invalide '%0' a été retiré pour exporter un modèle valide.",
	"dialog.resize_texture.fill": "Remplir avec",
	"dialog.resize_texture.fill.transparent": "Transparent",
	"dialog.resize_texture.fill.color": "Couleur",
	"dialog.resize_texture.fill.repeat": "Répéter",
	"dialog.scale.element_pivot": "Pivot d'élément",
	"dialog.scale.selection_center": "Centre de la sélection",
	"dialog.create_gif.length_mode": "Mode Longueur",
	"dialog.create_gif.length_mode.seconds": "Secondes",
	"dialog.create_gif.length_mode.frames": "Images",
	"dialog.create_gif.length_mode.animation": "Longueur d'animation",
	"dialog.create_gif.length_mode.turntable": "Rotation platine",
	"dialog.save_angle.projection": "Projection",
	"dialog.save_angle.projection.perspective": "Perspective",
	"dialog.save_angle.projection.orthographic": "Orthographique",
	"dialog.sketchfab_uploader.animations": "Animations",
	"dialog.settings.theme": "Thème",
	"settings.category.interface": "Interface",
	"settings.preview_checkerboard": "Aperçu du damier",
	"settings.preview_checkerboard.desc": "Affiche/masque le damier d'arrière-plan de l'aperçu",
	"settings.uv_checkerboard": "Damier de l'éditeur UV",
	"settings.uv_checkerboard.desc": "Affiche/masque le damier d'arrière-plan de l'éditeur UV",
	"category.paint": "Peinture",
	"action.fill_mode.color_connected": "Couleurs connectées",
	"action.draw_shape_type": "Type d'ombre",
	"action.draw_shape_type.rectangle": "Rectangle",
	"action.draw_shape_type.rectangle_h": "Rectangle (vide)",
	"action.draw_shape_type.ellipse": "Ellipse",
	"action.draw_shape_type.ellipse_h": "Ellipse (vide)",
	"action.draw_shape_type.line": "Ligne",
	"action.mirror_painting": "Peinture en miroir",
	"action.mirror_painting.description": "Renverse vos traits de l'autre côté du modèle",
	"action.lock_alpha": "Verrouiller canal alpha",
	"action.lock_alpha.description": "Verrouille la transparence de tous les pixels",
	"action.draw_shape_tool": "Dessiner forme",
	"action.draw_shape_tool.desc": "Outil de dessin d'ombres simples pour les textures",
	"action.export_gltf": "Exporter en tant que gITF",
	"action.export_gltf.desc": "Exporter le modèle et les animations en tant que fichier gITF compatible avec d'autres applications 3D",
	"action.transform_space": "Transformer espace",
	"action.transform_space.desc": "Transformation d'espace par défaut pour éléments et segments",
	"action.transform_space.global": "Global",
	"action.transform_space.local": "Local",
	"action.toggle_camera_projection": "Activer/désactiver projection caméra",
	"action.toggle_camera_projection.desc": "Bascule la projection caméra entre perspective et orthographique",
	"action.load_camera_angle": "Angle de caméra : %0",
	"action.load_camera_angle.desc": "Charge l'angle de caméra '%0'",
	"action.slider_face_tint": "Index de teinte",
	"action.slider_face_tint.desc": "Définit l'index de teinte de la face actuelle. -1 indique qu'il n'est pas défini.",
	"menu.help.quickstart": "Wizard démarrage rapide",
	"menu.help.developer": "Développeur",
	"menu.help.developer.dev_tools": "Ouvrir outils développeur",
	"menu.help.developer.reset_storage": "Formatage d'usine",
	"menu.help.developer.reset_storage.confirm": "Voulez-vous vraiment réinitialiser Blockbench à ses paramètres d'usine ? Cela effacera tous les paramètres personnalisés, raccourcis et plugins installés.",
	"menu.help.developer.cache_reload": "Rechargement cache",
	"menu.preview.orthographic": "Orthographique",
	"menu.preview.save_angle": "Sauvegarder angle…",
	"menu.preview.angle": "Angles",
	"menu.preview.angle.initial": "Angle initial",
	"menu.preview.maximize": "Maximiser",
	"uv_editor.copy_selection": "Copier la sélection",
	"uv_editor.paste_selection": "Coller la sélection",
	"uv_editor.copy_paste_tool.place": "Placer",
	"uv_editor.copy_paste_tool.mirror_x": "Miroir X",
	"uv_editor.copy_paste_tool.mirror_y": "Miroir Y",
	"uv_editor.copy_paste_tool.rotate": "Rotation de 90 degrés",
	"dialog.project.modded_entity_version": "Version de l'export",
	"dialog.save_angle.position": "Position de la caméra",
	"dialog.save_angle.target": "Point focal",
	"dialog.skin.pose": "Pose",
	"layout.color.frame": "Fenètre",
	"layout.color.frame.desc": "Bordure et titre de la fenètre",
	"settings.large_grid_size": "Taille de la grille",
	"settings.large_grid_size.desc": "Taille de la grille",
	"action.load_plugin_from_url": "Charger un plugin via une URL",
	"action.load_plugin_from_url.desc": "Charge un plugin en fournissant l'URL",
	"action.cube_counter.desc": "Affiche le nombre de cubes actuel et autres statistiques",
	"action.unlock_everything": "Débloquer tout",
	"action.unlock_everything.desc": "Débloque tous les groupes et éléments dans la liste",
	"action.load_palette": "Charger palette",
	"action.load_palette.desc": "Charge l'un des préréglages de palette",
	"action.toggle_locked": "Activer/désactiver verrouillage",
	"action.toggle_locked.desc": "Verrouille/déverrouille les éléments sélectionnés",
	"action.apply_display_preset": "Appliquer préréglage",
	"action.apply_display_preset.desc": "Applique un préréglage d'affichage par défaut, ou personnalisé",
	"action.apply_display_preset.here": "Appliquer à cet emplacement",
	"action.apply_display_preset.everywhere": "Appliquer à tous les emplacements",
	"action.resolve_keyframe_expressions": "Résoudre image clé",
	"action.resolve_keyframe_expressions.desc": "Résout les expressions mathématiques des images clés sélectionnées",
	"action.fold_all_animations": "Plier tous les animateurs",
	"menu.palette.load.empty": "Vide",
	"switches.lock": "Verrouiller",
	"settings.render_sides": "Afficher côtés",
	"settings.render_sides.desc": "Sélectionner quel côté d'une face est affiché",
	"settings.render_sides.auto": "Auto",
	"settings.render_sides.front": "Extérieur",
	"settings.render_sides.double": "Intérieur et extérieur",
	"generic.enable": "Activé",
	"generic.disable": "Désactivé",
	"generic.redacted": "Censuré",
	"dialog.select_texture.import_all": "Importer tout",
	"dialog.skin.layer_template": "Couche de texture",
	"about.version.up_to_date": "À jour",
	"about.version.update_available": "La version %0 est disponible",
	"settings.category.application": "Application",
	"settings.streamer_mode": "Mode Streamer",
	"settings.streamer_mode.desc": "Masque des informations sensibles telles que les modèles récents",
	"settings.automatic_updates": "Mises à jour automatiques",
	"settings.automatic_updates.desc": "Télécharge les nouvelles mises à jour automatiquement et garde Blockbench à jour",
	"action.rotation_space": "Espace de rotation",
	"action.focus_on_selection": "Centrer la vue sur la sélection",
	"action.focus_on_selection.desc": "Aligne la caméra en direction du centre de la sélection actuelle",
	"action.jump_to_timeline_start": "Passer au début de l'animation",
	"action.jump_to_timeline_end": "Passer à la fin de l'animation",
	"menu.help.updating": "Mise à jour en cours (%0%)",
	"menu.help.update_failed": "Échec de la mise à jour",
	"menu.animation.loop.once": "Lire une fois",
	"menu.animation.loop.hold": "Rester à la dernière image",
	"menu.animation.loop.loop": "Boucle",
	"interface.streamer_mode_on": "Mode Streamer activé",
	"generic.reset": "Réinitialiser",
	"generic.restore": "Restaurer",
	"keys.mousewheel": "Molette",
	"message.delete_animation.title": "Effacer l'animation",
	"message.delete_animation.message": "L'animation a été retirée de Blockbench. Voulez-vous aussi effacer l'animation du fichier dans lequel elle était sauvegardée ?",
	"message.no_animation_to_import": "Aucune animation à importer",
	"dialog.material_instances.title": "Instances matérielles",
	"dialog.animation_import.title": "Sélectionner des animations à importer",
	"dialog.create_texture.padding": "Rembourrage",
	"settings.fov": "FOV",
	"settings.fov.desc": "Champ de vision de la caméra. La valeur par défaut est 45.",
	"settings.minify_bbmodel": "Fichiers de projet minimisés",
	"settings.minify_bbmodel.desc": "Écrit l'intégralité des fichiers .bbmodel sur une seule ligne",
	"action.edit_material_instances": "Modifier les instances matérielles",
	"action.edit_material_instances.desc": "Modifier les noms d'instances matérielles pour des géométries de blocs Bedrock",
	"action.save_all_animations": "Sauvegarder toutes les animations",
	"action.save_all_animations.desc": "Sauvegarde toutes les animations actuellement chargées",
	"action.keyframe_interpolation": "Interpolation",
	"action.keyframe_interpolation.desc": "Sélectionner le mode d'interpolation des images clés",
	"action.keyframe_interpolation.linear": "Linéaire",
	"action.keyframe_interpolation.catmullrom": "Lisse",
	"action.timeline_focus.hide_empty": "Masquer les canaux vides",
	"menu.file.preferences": "Préférences",
	"menu.animation.blend_weight": "Poids de fondu",
	"menu.animation.save": "Enregistrer",
	"menu.animation.properties": "Propriétés…",
	"menu.animation.file": "Fichier",
	"menu.animation.snapping": "Alignement",
	"menu.animation.open_location": "Ouvrir l'emplacement du fichier",
	"panel.keyframe.add_data_point": "Ajouter un point de donnée d'image clé",
	"panel.keyframe.remove_data_point": "Retirer un point de donnée",
	"panel.keyframe.pre": "Pré",
	"panel.keyframe.post": "Post",
	"generic.all": "Tout",
	"message.small_face_dimensions.title": "Dimensions des Faces imcompatibles",
	"message.small_face_dimensions.message": "La sélection contient des faces plus petite que 1 unité dans une direction. Le système de cartographie Encadrement UV considère toutes les faces inférieures à ce seuil comme ayant une largeur de 0 pixel. La texture sur ces faces est donc susceptible de ne pas fonctionner correctement.",
	"message.small_face_dimensions.face_uv": "Le format actuel prend en charge les cartes UV par face qui peuvent gérer de petites dimensions de faces. Allez dans Fichier → Projet… et choisissez UV par face pour Mode UV.",
	"dialog.plugins.outdated_client": "Requis une nouvelle version de Blockbench",
	"dialog.plugins.outdated_plugin": "Le plugin n'est pas à jour et ne fonctionne pas avec cette version de Blockbench",
	"settings.motion_trails": "Trainée de Mouvement",
	"settings.motion_trails.desc": "Montrer les trainées de mouvement dans l'éditeur d'animation",
	"settings.antialiasing": "Anticrénélage",
	"settings.antialiasing.desc": "Active l'anti-aliasing dans l'aperçu. Redémarrez Blockbench pour appliquer les modifications.",
	"action.timeline_frame_back": "Sauter d'1 image en arrière",
	"action.timeline_frame_forth": "Sauter d'1 image en avant",
	"panel.bone.ik": "Cinématique inverse (expérimental)",
	"settings.particle_tick_rate": "Fréquence des particules",
	"settings.particle_tick_rate.desc": "Fréquence de rafraîchissement des effets de particules, en rafraîchissements par seconde. 30 par défaut.",
	"action.lock_motion_trail": "Verrouiller trajectoire",
	"action.lock_motion_trail.desc": "Verrouille la ligne de trajectoire au groupe actuellement sélectionné",
	"menu.animation_file.unload": "Décharger fichier d'animation",
	"data.null_object": "Objet nul",
	"status_bar.toggle_sidebar": "Affiche/masque la barre d'infos",
	"message.load_plugin_failed.title": "Le chargement du plugin a échoué",
	"message.load_plugin_failed.message": "Assurez-vous que le nom de base du fichier du plugin correspond à l'ID de plugin `%0`, comme indiqué dans Plugin.register().",
	"dialog.project.uv_mode": "Mode UV",
	"dialog.project.uv_mode.box_uv": "Encadrement UV",
	"dialog.project.uv_mode.face_uv": "UV par face",
	"dialog.project.texture_size": "Taille de texture",
	"dialog.animation_export.title": "Sélectionner les animations à exporter",
	"dialog.create_texture.rearrange_uv": "Réarranger UV",
	"layout.color.subtle_text": "Texte subtil",
	"layout.color.subtle_text.desc": "Couleur de texte secondaire avec moins de contraste",
	"settings.interface_scale": "Taille de l'interface",
	"settings.interface_scale.desc": "Taille de toute l'interface Blockbench",
	"settings.background_rendering": "Rendu de l'arrière-plan",
	"settings.background_rendering.desc": "Met à jour l'aperçu quand la fenêtre n'est pas sélectionnée",
	"settings.ctrl_shift_size": "Résolution de Ctrl + Shift",
	"settings.ctrl_shift_size.desc": "Résolution de la grille lorsque vous maintenez Ctrl et Shift",
	"settings.hardware_acceleration": "Accélération matérielle",
	"settings.hardware_acceleration.desc": "Sous-traite les tâches de rendu à la carte graphique. Redémarrez Blockbench pour appliquer ces changements.",
	"action.explode_skin_model": "Éclater le modèle de skin",
	"action.explode_skin_model.desc": "Active/désactive une vue éclatée qui permet d'accéder aux faces cachées",
	"action.export_minecraft_skin": "Exporter en skin Minecraft",
	"action.export_minecraft_skin.desc": "Exporte le skin pour Minecraft, en tant que texture PNG",
	"action.add_null_object": "Ajouter objet nul",
	"action.add_null_object.desc": "Ajoute un nouvel objet nul",
	"action.animated_texture_frame": "Image de texture animée",
	"action.animated_texture_frame.desc": "Définit l'image actuelle de la texture animée",
	"action.export_animation_file": "Exporter les animations…",
	"action.export_animation_file.desc": "Exporte une sélection d'animations vers un nouveau fichier",
	"action.timeline_graph_editor": "Activer/désactiver l'éditeur de graphe",
	"action.timeline_graph_editor.desc": "Bascule la timeline entre l'éditeur de graphe et la vue en images clés",
	"menu.file.recent.clear": "Vider les fichiers récents",
	"switches.shade": "Nuance",
	"generic.share": "Partager",
	"dates.minute": "%0 minute",
	"dates.minutes": "%0 minutes",
	"dates.hour": "%0 heure",
	"dates.hours": "%0 heures",
	"dates.day": "%0 jour",
	"dates.days": "%0 jours",
	"dates.week": "%0 semaine",
	"dates.weeks": "%0 semaines",
	"dates.year": "%0 an",
	"dates.years": "%0 ans",
	"message.installed_plugin": "Le plugin %0 a été installé avec succès",
	"message.installed_plugin_fail": "Le plugin %0 n'a pas pu être installé",
	"dialog.share_model.title": "Partager modèle",
	"dialog.share_model.expire_time": "Date d'expiration",
	"dialog.share_model.failed": "Le modèle n'a pas pu être uploadé",
	"action.import_java_block_model": "Ajouter modèle bloc/item Java",
	"action.import_java_block_model.desc": "Ajoute un modèle Java de bloc/d'item au modèle actuel depuis un fichier json",
	"action.share_model": "Partager…",
	"action.share_model.desc": "Génère un lien court pour partager votre modèle",
	"action.import_project": "Importer projet",
	"action.import_project.desc": "Importe un projet tiers au projet actuel depuis un fichier .bbmodel",
	"dialog.toolbar_edit.hidden_tools": "Certains outils pourraient être masqués car ils ne sont pas disponibles dans le mode, le format, ou la situation actuelle.",
	"settings.camera_near_plane": "Caméra proche du plan",
	"settings.camera_near_plane.desc": "La distance minimale de la caméra à l'endroit où les objets sont affichés. Une valeur plus importante diminue le conflit en Z. La valeur par défaut est 1.",
	"mode.start.keymap_preference.desc": "Si vous êtes nouveau sur Blockbench et êtes habitué à un autre logiciel 3D, vous pouvez sélectionner une configuration clavier adaptée pour faciliter votre transition. Vous pourrez changer ce préréglage ou des commandes particulières plus tard dans les paramètres.",
	"message.load_keymap": "Voulez-vous vraiment charger cette configuration clavier ? Cela va écraser vos commandes actuelles.",
	"message.keymap_loaded": "Configuration clavier chargée",
	"dialog.convert_project.current_format": "Format acuel",
	"dialog.create_texture.rearrange_uv.desc": "Créer une nouvelle disposition UV donne à chaque face sa propre place sur la texture",
	"dialog.create_texture.power.desc": "Verrouille la taille de texture automatique sur une puissance de 2, comme 64 ou 128. Cela est nécessaire pour certains moteurs de rendu.",
	"dialog.create_texture.double_use.desc": "Si deux éléments ont déjà le même espace UV attribué, cela sera conservé dans la nouvelle disposition",
	"dialog.create_texture.padding.desc": "Ajoutez un petit décalage entre les différentes parties du modèle",
	"dialog.create_texture.resolution.desc": "La résolution de base de la texture, en pixels par mètre. La taille réelle de la carte de texture peut changer selon la quantité et la taille des éléments.",
	"dialog.create_gif.color": "Couleur de l'arrière plan",
	"dialog.save_angle.zoom": "Zoom",
	"dialog.skin.variant": "Variante",
	"dialog.flip_animation.info": "Deux segments opposés sont identifiés par les mots-clés « gauche » et « droite » dans leur nom.",
	"dialog.export_private_settings.title": "Paramètres privés",
	"dialog.export_private_settings.message": "Votre fichier contient les informations privées suivantes : **%0**. Retirez ces valeurs si vous comptez partager le fichier avec quelqu'un d'autre.",
	"dialog.export_private_settings.keep": "Garder",
	"settings.timecode_frame_number": "Afficher les codes temporels sous forme de numéros d'image",
	"settings.timecode_frame_number.desc": "Affiche des timecodes fractionnaires dans la timeline sous forme de numéro d'image au lieu de centième de seconde",
	"settings.animation_sample_rate": "Taux d'échantillonnage de l'animation",
	"settings.animation_sample_rate.desc": "Fréquence en échantillons par seconde pour les courbes que le format respectif ne prend pas nativement en charge",
	"keybind.preview_zoom": "Zoom de l'aperçu",
	"action.gradient_tool": "Outil dégradé",
	"action.gradient_tool.desc": "Crée un dégradé de couleurs sur votre texture",
	"action.import_settings": "Importer des paramètres",
	"action.import_settings.desc": "Importer un fichier .bbsettings",
	"action.export_settings": "Exporter les paramètres",
	"action.export_settings.desc": "Exporter ces paramètres Blockbench dans un fichier .bbsettings",
	"action.load_keymap": "Charger une configuration clavier",
	"action.load_keymap.default": "Par défaut (pavé tactile/souris)",
	"action.load_keymap.mouse": "Par défaut (souris)",
	"action.load_keymap.default.desc": "Raccourcis clavier Blockbench par défaut, avec navigation optimisée pour utilisation sur pavé tactile d'ordinateur portable",
	"action.load_keymap.mouse.desc": "Raccourcis clavier Blockbench par défaut, avec navigation assignée au bouton de la molette de la souris",
	"action.load_keymap.blender.desc": "Configuration clavier pour les utilisateurs habitués aux commandes de Blender",
	"action.load_keymap.cinema4d.desc": "Configuration clavier pour les utilisateurs habitués aux commandes de Cinema 4D",
	"action.load_keymap.maya.desc": "Keymap pour les utilisateurs habitués aux commandes d'Autodesk Maya",
	"action.import_keymap": "Importer une configuration clavier",
	"action.import_keymap.desc": "Importer des raccourcis clavier depuis un fichier .bbkeymap",
	"action.export_keymap": "Exporter la configuration clavier",
	"action.export_keymap.desc": "Exporte les raccourcis clavier actuels dans un fichier .bbkeymap",
	"action.edit_history": "Modifier l'historique...",
	"action.edit_history.desc": "Affiche l'historique des modifications pour annuler ou rétablir des étapes",
	"action.group_elements": "Grouper les éléments",
	"action.group_elements.desc": "Rassemble les éléments sélectionnés sous un nouveau groupe",
	"action.unfold_groups": "Déplier les groupes",
	"action.unfold_groups.desc": "Déplie tous les groupes dans la liste",
	"action.edit_bedrock_binding": "Modifier les associations…",
	"action.edit_bedrock_binding.desc": "Modifier le segment auquel la géométrie est liée",
	"action.pick_screen_color": "Choisir la couleur de l'écran",
	"action.pick_screen_color.desc": "Choisir une couleur quelque part sur votre écran",
	"action.view_mode": "Mode d'affichage",
	"action.view_mode.desc": "Change le mode d'affichage du modèle",
	"action.view_mode.textured": "Texturé",
	"action.view_mode.solid": "Solide",
	"action.view_mode.wireframe": "Squelette",
	"action.toggle_sidebars": "Activer/désactiver les barres latérales",
	"action.toggle_sidebars.desc": "Active/désactive les bandes sur les côtés",
	"action.set_animation_end": "Définir la fin de l'animation",
	"action.set_animation_end.desc": "Définit la fin de l'animation sélectionnée à l'instant actuel sur la timeline",
	"action.flip_animation": "Retourner l'animation",
	"action.flip_animation.desc": "Retourne une partie d'une animation en copiant les images clés sélectionnées de l'autre côté du modèle",
	"action.graph_editor_zero_line": "Inclure la ligne zéro",
	"action.graph_editor_zero_line.desc": "Si, oui ou non, l'éditeur de graphiques affiche toujours la ligne zéro",
	"menu.texture.render_mode": "Mode de rendu",
	"menu.texture.render_mode.emissive": "Émissif",
	"menu.texture.render_mode.layered": "Superposé",
	"menu.preview.angle.edit": "Modifier l'angle…",
	"menu.animation.start_delay": "Délai de démarrage",
	"menu.animation.loop_delay": "Délai de reprise",
	"menu.animation.flip_keyframes": "Retourner les images clés",
	"menu.mobile_keyboard.disable_all": "Tout désactiver",
	"panel.keyframe.toggle_uniform_scale": "Basculer l'échelle uniforme",
	"camera_angle.common_isometric_right": "Droite isométrique (2:1)",
	"camera_angle.common_isometric_left": "Gauche isométrique (2:1)",
	"camera_angle.true_isometric_right": "Vraie droite isométrique (30°)",
	"camera_angle.true_isometric_left": "Vraie gauche isométrique (30°)",
	"menu.help.wiki": "Wiki Blockbench",
	"settings.update_to_prereleases": "Mettre à jour vers les versions expérimentales",
	"settings.update_to_prereleases.desc": "Met à jour Blockbench automatiquement vers des versions bêta pour tester les nouvelles fonctionnalités. Les versions expérimentales peuvent être instables, n'activez pas cette option si vous vous servez de Blockbench pour le travail ou d'autres projets importants.",
	"data.separator.spacer": "Séparateur",
	"data.separator.linebreak": "Retour à la ligne",
	"data.setting": "Paramètre",
	"generic.select_all": "Tout sélectionner",
	"generic.select_none": "Vider la sélection",
	"projects.new_tab": "Nouvel onglet",
	"projects.close_tab": "Fermer l'onglet",
	"message.invalid_format.title": "Format invalide",
	"message.invalid_format.message": "Ce modèle a été fait au format '%0', qui n'est pas disponible dans votre installation Blockbench. Il vous faut sans doute un plugin spécifique pour l’ouvrir correctement.",
	"message.invalid_link": "Le lien modèle est invalide ou a expiré",
	"message.default_textures.current": "Chemin actuel",
	"message.update_after_restart": "La mise à jour sera installée après le prochain redémarrage",
	"message.copy_paste_tool_viewport": "Cet outil ne peut être utilisé que dans le panneau UV",
	"dialog.project.shadow_size": "Taille des ombres",
	"dialog.find_replace.target": "Cible",
	"dialog.find_replace.target.element_names": "Nom des éléments",
	"dialog.find_replace.target.group_names": "Nom des groupes",
	"dialog.find_replace.target.animation_names": "Nom des animations",
	"dialog.find_replace.target.keyframe_values": "Valeur des images clés",
	"dialog.find_replace.find": "Rechercher",
	"dialog.find_replace.replace": "Remplacer",
	"dialog.find_replace.regex": "Expression régulière",
	"dialog.add_primitive.shape": "Forme",
	"dialog.add_primitive.shape.circle": "Cercle",
	"dialog.add_primitive.shape.tube": "Tube",
	"dialog.add_primitive.shape.cone": "Cône",
	"dialog.add_primitive.shape.cylinder": "Cylindre",
	"dialog.add_primitive.shape.sphere": "Sphère",
	"dialog.add_primitive.shape.torus": "Tore",
	"dialog.add_primitive.shape.cube": "Cube",
	"dialog.add_primitive.shape.pyramid": "Pyramide",
	"dialog.add_primitive.diameter": "Diamètre",
	"dialog.add_primitive.height": "Hauteur",
	"dialog.add_primitive.sides": "Côtés",
	"dialog.add_primitive.minor_diameter": "Épaisseur",
	"dialog.add_primitive.minor_sides": "Côtés mineurs",
	"dialog.create_texture.combine_polys": "Combiner les faces",
	"dialog.create_texture.combine_polys.desc": "Combine les faces coplanaires sélectionnées en une seule section UV",
	"dialog.model_stats.meshes": "Maillage",
	"dialog.export_private_settings.omit": "Laisser vide",
	"layout.select": "Sélectionner",
	"layout.options": "Options",
	"layout.color": "Schéma de couleur",
	"layout.documentation": "Documentation",
	"layout.color.bright_ui_text": "Interface claire",
	"layout.color.bright_ui_text.desc": "Texte sur arrière-plan clair",
	"layout.name": "Nom",
	"layout.author": "Auteur",
	"settings.dialog.desc": "Affiche le dialogue \"%0\"",
	"settings.export_empty_groups": "Exporter les groupes vides",
	"settings.export_empty_groups.desc": "Inclut les groupes sans contenu dans les fichiers exportés",
	"category.separators": "Séparateurs",
	"keybind.preview_area_select": "Sélection de zone",
	"action.color_erase_mode": "Mode Gomme",
	"action.color_erase_mode.desc": "En mode Gomme, les outils tels que Remplir et Rectangle retirent des couleurs au lieu d'en ajouter",
	"action.open_from_link": "Ouvrir modèle à partir du lien…",
	"action.open_from_link.desc": "Ouvre un modèle depuis une URL blckbn.ch",
	"action.import_obj": "Importer modèle OBJ",
	"action.import_obj.desc": "Importe des objets depuis un modèle OBJ en tant que maillage",
	"action.add_plugin": "Installer un plugin",
	"action.add_plugin.desc": "Installe un plugin à partir du Contrôle d'action",
	"action.remove_plugin": "Désinstaller plugin",
	"action.remove_plugin.desc": "Désinstalle un plugin à partir du Contrôle d'action",
	"action.add_mesh": "Ajouter maille",
	"action.add_mesh.desc": "Ajoute une nouvelle maille",
	"action.add_texture_mesh": "Ajouter une maille de texture",
	"action.add_texture_mesh.desc": "Ajoute une nouvelle maille de texture",
	"action.find_replace": "Rechercher/remplacer…",
	"action.find_replace.desc": "Rechercher et remplacer des parties de noms",
	"action.hide_everything_except_selection": "Masquer tout sauf la sélection",
	"action.hide_everything_except_selection.desc": "Bascule la visibilité de tous les éléments, hormis ceux qui sont sélectionnés",
	"action.transform_space.normal": "Normal",
	"action.selection_mode": "Mode de sélection",
	"action.selection_mode.desc": "Change comment les éléments peuvent être sélectionnés dans la fenêtre",
	"action.selection_mode.object": "Objet",
	"action.selection_mode.face": "Face",
	"action.selection_mode.vertex": "Sommet",
	"action.create_face": "Créer une face",
	"action.create_face.desc": "Crée une nouvelle face ou une ligne entre les sommets sélectionnés",
	"action.convert_to_mesh": "Convertir en maillage",
	"action.convert_to_mesh.desc": "Convertit les éléments sélectionnés en maillage",
	"action.invert_face": "Inverser les faces",
	"action.invert_face.desc": "Inverse les faces sélectionnées pour les faire pointer dans le sens opposé",
	"action.extrude_mesh_selection": "Extruder la sélection",
	"action.extrude_mesh_selection.desc": "Extrude les parties sélectionnées du maillage",
	"action.loop_cut": "Couper boucle",
	"action.loop_cut.desc": "Sépare le maillage en une boucle à travers l'arête sélectionnée",
	"action.merge_meshes": "Fusionner mailles",
	"action.merge_meshes.desc": "Fusionne plusieurs mailles en une seule",
	"action.keyframe_uniform": "Mise à l'échelle uniforme",
	"action.keyframe_uniform.desc": "Autorise la mise à l'échelle uniforme sur les images clés sélectionnées",
	"menu.locator.ignore_inherited_scale": "Ignorer l'échelle héritée",
	"menu.texture.elements": "Appliquée aux éléments",
	"uv_editor.transparent_face": "Face transparente",
	"display.pose_angle": "Angle de pose (aperçu uniquement)",
	"data.mesh": "Maillage",
	"dialog.create_texture.type": "Type",
	"dialog.create_texture.type.blank": "Vierge",
	"dialog.create_texture.type.template": "Modèle de texture",
	"dialog.create_texture.type.color_map": "Modèle de couleur unie",
	"dialog.sketchfab_uploader.suggested_tags": "Tags suggérés",
	"dialog.sketchfab_uploader.category": "Catégorie",
	"dialog.sketchfab_uploader.category2": "Catégorie 2",
	"layout.restore_backup": "Votre thème personnalisé « %0 » a été écrasé. Cliquez ici pour le restaurer.",
	"layout.borders": "Bordures",
	"action.fill_mode.element": "Élément",
	"action.inset_mesh_selection": "Encarter sélection",
	"action.inset_mesh_selection.desc": "Intègre les parties sélectionnées du maillage",
	"action.dissolve_edges": "Dissoudre les bords",
	"action.dissolve_edges.desc": "Dissout les arêtes sélectionnées d'un maillage et fusionne les faces qu'elles divisent",
	"action.split_mesh": "Séparer maillage",
	"action.split_mesh.desc": "Sépare les faces sélectionnées du maillage en un nouveau maillage",
	"action.merge_vertices": "Fusionner les sommets",
	"action.merge_vertices.desc": "Fusionne les sommets sélectionnés à la position du premier sommet sélectionné",
	"action.view_mode.normal": "Point de vue normal",
	"action.snap_uv_to_pixels": "Aligner UV aux pixels",
	"action.snap_uv_to_pixels.desc": "Aligne (aimante) les sommets UV sélectionnés à la grille de pixels",
	"menu.file.import.import_open_project": "Importer un projet ouvert",
	"menu.help.unlock_projects": "Débloquer tous les projets",
	"status_bar.selection.faces": "%0 faces",
	"status_bar.selection.vertices": "%0 sommets",
	"message.merged_vertices": "%0 sommets ont été trouvés et fusionné depuis %1 emplacements",
	"settings.vertex_merge_distance": "Distance de fusion des sommets",
	"settings.vertex_merge_distance.desc": "Distance avant laquelle les sommets sont fusionnés en utilisant la fusion par distance",
	"settings.show_only_selected_uv": "Afficher UV sélectionnés uniquement",
	"settings.show_only_selected_uv.desc": "N'afficher que les faces UV sélectionnées dans l'éditeur UV par défaut",
	"action.merge_vertices.merge_all": "Tout fusionner",
	"action.merge_vertices.merge_all_in_center": "Fusionne tout, au centre",
	"action.merge_vertices.merge_by_distance": "Fusion par distnace",
	"action.merge_vertices.merge_by_distance_in_center": "Fusionne par distance, au centre",
	"action.uv_rotate_left": "Tourner UV à gauche",
	"action.uv_rotate_left.desc": "Tourne les faces UV sélectionnées dans le sens antihoraire",
	"action.uv_rotate_right": "Tourner UV à droite",
	"action.uv_rotate_right.desc": "Tourne les faces UV sélectionnés dans le sens horaire",
	"menu.uv.display_uv": "Afficher UV",
	"menu.uv.display_uv.selected_faces": "Faces sélectionnées",
	"menu.uv.display_uv.selected_elements": "Toutes les faces",
	"menu.uv.display_uv.all_elements": "Toutes les faces sur tous les éléments",
	"menu.paste.face": "Face UV",
	"menu.paste.mesh_selection": "Sélection maillage",
	"menu.paste.outliner": "Éléments",
	"uv_editor.show_all_faces": "Montrer toutes lesfaces",
	"uv_editor.show_selected_faces": "Montrer faces sélectionnées",
	"status_bar.selection.edges": "%0 arêtes",
	"action.selection_mode.edge": "Arête",
	"message.cannot_re_import.title": "Le modèle ne peut être réimporté",
	"message.cannot_re_import.message": "Ce format d'export de modèle ne peut être réimporté vers Blockbench. Assurez-vous de sauvegarder votre modèle en tant que fichier de projet.",
	"generic.default": "Par défaut",
	"units.pixels_per_meter": "%0 pixels par mètre",
	"mode.pose": "Pose",
	"modifier_actions.resize_both_sides": "Redimentionner dans les deux directions",
	"modifier_actions.resize_one_side": "Redimentionner dans une direction",
	"modifier_actions.draw_line": "Dessiner ligne",
	"modifier_actions.drag_without_snapping": "Faire glisser sans alignement",
	"modifier_actions.stretch_keyframes": "Étirer les images clés",
	"modifier_actions.resize_background": "Redimentionner l'arrière-plan",
	"modifier_actions.select_multiple": "Sélection multiple",
	"modifier_actions.select_range": "Gamme de sélection",
	"modifier_actions.drag_to_duplicate": "Faire glisser pour dupliquer",
	"modifier_actions.uniform_scaling": "Mise à l'échelle uniforme",
	"modifier_actions.snap_direction": "Aligner direction",
	"message.no_valid_elements": "Aucun élément valide sélectionné…",
	"dialog.add_primitive.shape.plane": "Plan",
	"dialog.save_angle.rotation_mode": "Mode de rotation",
	"dialog.save_angle.rotation": "Rotation",
	"dialog.save_angle.fov": "FOV",
	"settings.hide_tab_bar": "Masquer automatiquement la barre d'onglets",
	"settings.hide_tab_bar.desc": "Masque la barre d'onglets lorsqu'un seul onglet est ouvert",
	"settings.status_bar_modifier_keys": "Suggérer touches de modification dans la barre de statut",
	"settings.status_bar_modifier_keys.desc": "Affiche des suggestions de touches de modification dans la barre de statut en fonction du contexte",
	"settings.ground_plane": "Plan de sol",
	"settings.ground_plane.desc": "Affiche un plan de sol sous le modèle",
	"settings.preview_paste_behavior": "Comportement par défaut du collage d'aperçu",
	"settings.preview_paste_behavior.desc": "Choisir ce qui se passe si vous collez quelque chose dans l'aperçu du mode Édition alors que plusieurs options sont disponibles",
	"settings.preview_paste_behavior.always_ask": "Toujours demander",
	"action.new_window": "Nouvelle fenêtre",
	"action.new_window.desc": "Ouvre une nouvelle fenêtre Blockbench",
	"action.export_collada": "Exporter modèle Collada (dae)",
	"action.export_collada.desc": "Exporte le modèle et les animations dans un fichier dae pour l'utiliser dans d'autres logiciels 3D",
	"action.paint_mode_uv_overlay": "Overlay UV",
	"action.paint_mode_uv_overlay.desc": "Affiche la carte UV sous forme d'overlay en mode Dessin",
	"action.bake_animation_into_model": "Intégrer l'animation au modèle",
	"action.bake_animation_into_model.desc": "Intègre l'image d'animation actuellement affichée au modèle. Seules la rotation et la position s'appliquent, la mise à l'échelle est ignorée.",
	"action.keyframe_interpolation.step": "Étape",
	"action.set_ik_target": "Définir une cible CI",
	"action.set_ik_target.desc": "Choisir le segment cible à faire déplacer par cet objet nul via la Cinématique inverse (CI)",
	"menu.action_control.type.tab": "Onglet",
	"menu.action_control.type.angle": "Angle de caméra",
	"menu.action_control.recent_in_streamer_mode": "Êtes-vous sûr ? Le mode Streamer est activé",
	"menu.action_control.recent_in_streamer_mode.desc": "Êtes vous sûr de vouloir afficher les modèles récents ?",
	"menu.tools": "Outils",
	"menu.file.recent.more": "Voir plus…",
	"menu.null_object.lock_ik_target_rotation": "Verrouiller la rotation de cible CI",
	"menu.animation_file.import_remaining": "Importer les animations restantes",
	"edit.loop_cut.offset": "Décalage",
	"edit.extrude_mesh_selection.extend": "Étendre",
	"cube.color.pink": "Rose",
	"cube.color.silver": "Argenté",
	"dialog.plugins.offline": "Pas de connexion à Internet",
	"dialog.create_texture.pixel_density": "Densité de pixels",
	"dialog.create_texture.pixel_density.desc": "La densité de pixels de la texture, en pixels par mètre. La taille de la carte de texture pourrait varier en fonction du nombre et de la taille des éléments.",
	"panel.skin_pose": "Pose",
	"panel.skin_pose.none": "Aucune",
	"panel.skin_pose.natural": "Naturelle",
	"panel.skin_pose.walking": "Marche",
	"panel.skin_pose.crouching": "Accroupi",
	"panel.skin_pose.sitting": "Assis",
	"panel.skin_pose.jumping": "En train de sauter",
	"panel.skin_pose.aiming": "En train de viser",
	"edit.loop_cut.direction": "Direction",
	"data.texture_mesh": "Maille texturée",
	"generic.left": "Gauche",
	"generic.right": "Droite",
	"mode.start.quick_setup": "Installation rapide",
	"mode.start.keymap": "Configuration clavier",
	"mode.start.quick_setup.more_themes": "Plus...",
	"dialog.resize_texture.animation_frames": "Cadres d'animation",
	"dialog.export_emission_map.title": "Carte des émissions d'exportation",
	"dialog.export_emission_map.format": "Format",
	"dialog.export_emission_map.format.luminance": "Luminance",
	"dialog.export_emission_map.format.luminance_inverted": "Luminance inversée",
	"dialog.export_emission_map.format.colors": "Couleurs",
	"dialog.export_emission_map.threshold": "Seuil de transparence",
	"dialog.export_emission_map.round_up": "Arrondir par excès à %0 x %1",
	"dialog.export_emission_map.flip_y": "Inverser l'axe Y",
	"dialog.select.type": "Type d'élément",
	"dialog.create_texture.max_edge_angle": "Seuil d'angle de bord",
	"dialog.create_texture.max_edge_angle.desc": "L'angle maximal entre deux faces auquel elles seront encore combinées",
	"dialog.create_texture.max_island_angle": "Seuil de l'angle de l'île",
	"dialog.create_texture.max_island_angle.desc": "L'angle maximum qui peut être combiné dans le même îlot UV",
	"settings.mobile_panel_side": "Côté panneau mobile",
	"settings.mobile_panel_side.desc": "Sélectionnez le côté des panneaux d'écran affichés lors de l'utilisation de Blockbench en orientation paysage",
	"settings.obj_face_export_mode": "Mode d'exportation de visage OBJ",
	"settings.obj_face_export_mode.desc": "Choisissez de laisser l'exportateur OBJ convertir toutes les faces en tris ou quads",
	"settings.obj_face_export_mode.both": "Défaut",
	"settings.obj_face_export_mode.tris": "Convertir en tris",
	"settings.obj_face_export_mode.quads": "Convertir en Quads",
	"action.seam_tool": "Outil de couture",
	"action.seam_tool.desc": "Outil pour définir les coutures UV sur les bords du maillage",
	"action.resolve_group": "Résoudre le groupe",
	"action.resolve_group.desc": "Résoudre le groupe tout en conservant ses enfants au même endroit",
	"action.move_to_group": "Déplacer vers le groupe",
	"action.move_to_group.desc": "Déplacer les éléments sélectionnés vers un autre groupe de contours",
	"action.select_seam": "Sélectionnez la couture UV",
	"action.select_seam.desc": "Sélectionnez le mode de couture UV pour les bords sélectionnés",
	"action.select_seam.auto": "Auto",
	"action.select_seam.join": "Rejoindre",
	"action.select_seam.divide": "Diviser",
	"action.adjust_brightness_contrast": "Ajuster la luminosité et le contraste...",
	"action.adjust_brightness_contrast.desc": "Ajuster la luminosité et le contraste de la texture sélectionnée",
	"action.adjust_saturation_hue": "Ajuster la saturation et la teinte...",
	"action.adjust_saturation_hue.desc": "Ajuster la saturation et la teinte de la texture sélectionnée",
	"action.invert_colors": "Inverser les couleurs",
	"action.invert_colors.desc": "Inverser toutes les couleurs de la texture sélectionnée",
	"action.adjust_curves": "Ajuster les courbes...",
	"action.adjust_curves.desc": "Ajuster les courbes de luminosité de la texture sélectionnée",
	"action.flip_texture_x": "Retourner la texture horizontalement",
	"action.flip_texture_y": "Retourner la texture verticalement",
	"action.resize_texture": "Redimensionner la texture...",
	"action.view_mode.uv": "Aperçu UV",
	"action.append_to_template": "Ajouter des éléments au modèle...",
	"action.append_to_template.desc": "Ajouter les éléments actuellement sélectionnés au modèle de texture",
	"action.move_texture_with_uv": "Déplacer la texture avec UV",
	"action.move_texture_with_uv.desc": "Déplacez la texture de la face lorsque vous faites glisser des faces UV",
	"action.timeline_setups": "Configurations de la chronologie",
	"action.save_timeline_setup": "Enregistrer la configuration de la chronologie...",
	"action.save_timeline_setup.desc": "Enregistrer un préréglage pour les animateurs et canaux actuellement sélectionnés",
	"menu.texture": "Texture",
	"menu.texture.render_mode.default": "Défaut",
	"menu.texture.merge_onto_texture": "Fusionner sur la texture ci-dessus",
	"menu.animation.unload": "Décharger",
	"panel.timeline": "Chronologie",
	"action.pan_tool": "Outil panoramique",
	"action.pan_tool.desc": "Outil pour naviguer dans la fenêtre et l'éditeur de texture",
	"mode.start.recent.favorite": "Marquer comme favori",
	"mode.start.info": "Information",
	"mode.start.target": "Cible",
	"mode.start.start": "Démarrer",
	"mode.start.create_new": "Créer un nouveau modèle",
	"mode.start.format.informations": "Bon à savoir:",
	"mode.start.format.resources": "Ressources:",
	"format.free.info.meshes": "Dans ce format, vous pouvez créer des modèles low poly à l'aide de cubes et de maillages de forme personnalisée.",
	"format.free.info.limitation": "Les modèles ne peuvent pas être chargés dans des jeux nécessitant des formats spécialisés, tels que Minecraft.",
	"format.skin.info.skin": "Ce format est conçu pour créer des skins Minecraft et des textures d'entités.",
	"format.skin.info.model": "Le modèle ne peut pas être modifié. Pour apporter des modifications au modèle, convertissez d'abord dans un format différent via **Fichier** > **Convertir le projet**.",
	"format.java_block.info.rotation": "Les rotations sont limitées à des pas de 22,5 degrés et à un axe par élément",
	"format.java_block.info.size": "Le modèle est limité à une taille de 3 par 3 par 3 blocs. Les paramètres d'affichage peuvent cependant agrandir les modèles d'articles",
	"format.java_block.info.animation": "Ce format ne prend pas en charge les animations dans Minecraft vanille. Si vous créez un mod, vous pouvez utiliser GeckoLib pour animer des modèles. Sinon, la seule façon d'animer est de changer le modèle à l'aide de commandes ou de textures animées.",
	"format.bedrock.info.textures": "Chaque modèle ne peut avoir qu'une seule texture",
	"format.bedrock_block": "Bloc de Bedrock",
	"format.bedrock_block.desc": "Modèle de bloc pour Minecraft Bedrock Edition",
	"format.modded_entity.info.integer_size": "La taille des cubes individuels est limitée à des nombres entiers.",
	"format.modded_entity.info.format": "Les modèles sont écrits en code Java au lieu de structures de données dédiées comme tous les autres formats d'exportation Blockbench.",
	"format.optifine_entity.info.optifine_required": "Les utilisateurs sans OptiFine installé ne verront pas le modèle.",
	"format.optifine_entity.info.pivots": "Les pivots osseux sont verrouillés, c'est donc une bonne idée de les laisser intacts.",
	"format_category.low_poly": "Faible Polygone",
	"format_category.minecraft": "Minecraft",
	"format_category.other": "Autre",
	"format_category.loaders": "Chargeurs",
	"message.recover_backup.recover": "Récupérer",
	"message.invalid_characters.title": "Chemin non valide",
	"message.invalid_characters.message": "Le chemin du fichier importé contient des caractères non valides, des lettres majuscules ou des espaces blancs. Les caractères pris en charge sont : %0",
	"dialog.share_model.thumbnail": "Vignette",
	"dialog.skin.high_res_texture": "Veuillez noter que les skins avec la résolution sélectionnée ne fonctionneront pas comme des skins Minecraft normaux. Sélectionnez une résolution inférieure.",
	"settings.allow_display_slot_mirror": "Autoriser la mise en miroir de l'affichage",
	"settings.allow_display_slot_mirror.desc": "Autoriser la mise en miroir des emplacements d'affichage pour les modèles d'éléments Java. AVERTISSEMENT : Cela ne fonctionne que dans Minecraft 1.14 ou antérieur ou dans des cas particuliers.",
	"action.switch_tabs": "Changer d'onglet",
	"action.switch_tabs.desc": "Faites défiler les onglets ouverts. Maintenez la touche Maj enfoncée pour faire un cycle dans la direction opposée.",
	"action.unselect_all": "Désélectionner tout",
	"action.save_palette": "Sauvegarder la palette...",
	"action.save_palette.desc": "Enregistrez la palette de couleurs actuelle dans Blockbench pour une utilisation ultérieure",
	"action.keyframe_column_create": "Créer une colonne d'images clés",
	"action.keyframe_column_create.desc": "Clé tous les canaux de la chronologie au code temporel actuel, s'ils ont déjà des images clés",
	"action.keyframe_column_select": "Sélectionner la colonne d'images clés",
	"action.keyframe_column_select.desc": "Sélectionner toutes les images clés de la timeline le long d'une colonne sous la tête de lecture.",
	"menu.uv": "UV",
	"menu.keyframe": "Image clé",
	"menu.palette.load.update": "Palette de mise à jour",
	"menu.palette.load.update.desc": "Met à jour cette palette avec les couleurs de la palette Blockbench actuelle",
	"menu.timeline_marker.set_time": "Régler le temps...",
	"uv_editor.scale_uv": "Échelle UV",
	"action.preview_scene": "Aperçu de la scène",
	"action.preview_scene.desc": "Modifier la scène d'aperçu du modèle",
	"preview_scene.minecraft_overworld": "Surmonde Minecraft",
	"preview_scene.minecraft_nether": "Nether Minecraft",
	"preview_scene.minecraft_end": "Fin de Minecraft",
	"dialog.project.modded_entity_flip_y": "Retourner l'axe Y",
	"preview_scene.studio": "Studio",
	"format.image": "Image",
	"modifier_actions.set_copy_source": "Définir la source de la copie",
	"message.load_images.title": "Charger les images",
	"message.load_images.edit_image": "Modifier les images",
	"dialog.add_primitive.align_edges": "Aligner les bords",
	"dialog.flip_animation.show_in_timeline": "Afficher les os modifiés dans la timeline",
	"settings.default_cube_size": "Taille du cube",
	"settings.default_cube_size.desc": "Définir la taille du cube par défaut lors de la création d'un nouveau cube",
	"settings.uniform_keyframe": "Échelle uniforme d'images clés",
	"settings.uniform_keyframe.desc": "Définit les échelles des images clés à une mise à l'échelle uniforme par défaut",
	"settings.nearest_rectangle_select": "Sélection du rectangle : Bord le plus proche",
	"settings.nearest_rectangle_select.desc": "Accrocher les sélections de rectangles au bord du pixel le plus proche, comme dans GIMP, au lieu de pixels entiers.",
	"settings.pick_color_opacity": "Choisir l'opacité des couleurs",
	"settings.pick_color_opacity.desc": "Choisir l'opacité de la couleur avec le sélecteur de couleur et définissez-la comme opacité du pinceau",
	"settings.paint_with_stylus_only": "Peindre avec le stylet uniquement",
	"settings.paint_with_stylus_only.desc": "Utiliser uniquement le stylet pour peindre, réserver la souris ou l'entrée tactile pour la navigation.",
	"action.copy_brush_mode": "Copier le mode du pinceau",
	"action.copy_brush_mode.copy": "Copier",
	"action.copy_brush_mode.pattern": "Motif",
	"action.copy_brush_mode.sample": "Échantillon",
	"action.brush_shape": "Forme du pinceau",
	"action.brush_shape.square": "Carré",
	"action.brush_shape.circle": "Cercle",
	"action.blend_mode": "Mode de fusion",
	"action.blend_mode.default": "Défaut",
	"action.blend_mode.set_opacity": "Définir l'opacité",
	"action.blend_mode.color": "Couleur",
	"action.blend_mode.behind": "Derrière",
	"action.blend_mode.multiply": "Multiplier",
	"action.blend_mode.divide": "Diviser",
	"action.blend_mode.add": "Ajouter",
	"action.blend_mode.subtract": "Soustraire",
	"action.blend_mode.screen": "Écran",
	"action.blend_mode.overlay": "Overlay",
	"action.blend_mode.hard_light": "Lumière forte",
	"action.blend_mode.difference": "Différence",
	"action.copy_brush": "Copier le pinceau",
	"action.copy_brush.desc": "Pinceau pour cloner des parties de votre texture ou dessiner des motifs",
	"action.validator_window": "Voir les problèmes du modèle...",
	"action.validator_window.desc": "Ouvre le validateur, qui répertorie les problèmes du modèle actuel.",
	"action.cancel_gif": "Annuler le GIF",
	"menu.text_edit.copy_vector": "Copier le vecteur",
	"menu.brush_presets.dialog": "Pinceaux préréglés...",
	"menu.brush_presets.pixel_brush": "Pinceau de pixels",
	"menu.brush_presets.smooth_brush": "Pinceau lisse",
	"menu.texture.edit_in_blockbench": "Modifier dans Blockbench",
	"menu.mirror_painting.axis": "Axe",
	"menu.mirror_painting.axis.desc": "Sélectionner l'axe sur lequel les traits de peinture seront reflétés.",
	"menu.mirror_painting.global": "Symétrie globale",
	"menu.mirror_painting.global.desc": "Activation de la peinture miroir sur le modèle dans l'espace global",
	"menu.mirror_painting.local": "Symétrie locale",
	"menu.mirror_painting.local.desc": "Permettre la peinture miroir dans l'espace local pour chaque élément",
	"menu.mirror_painting.texture_frames": "Images de texture animées",
	"menu.mirror_painting.texture_frames.desc": "Refléter les coups de pinceau pour chaque image des textures animées",
	"format.bedrock_block.info.size_limit": "La taille totale d'un bloc est limitée à 30 pixels dans toutes les dimensions. La limite peut être décentrée dans toutes les directions de 7 pixels par rapport au centre du bloc.",
	"format.bedrock_block.info.textures": "De multiples textures peuvent être appliquées à différents cubes dans Blockbench, mais cela nécessitent une configuration supplémentaire dans le pack de comportement pour fonctionner correctement dans le jeu.",
	"format.image.desc": "Modifier des images dans l'éditeur d'images 2D",
	"generic.delete_all": "Supprimer tout",
	"message.child_model_only.open": "Ouvrir le parent",
	"message.child_model_only.open_with_textures": "Ouvrir le parent & adopter ses textures",
	"dialog.project.credit": "Crédit",
	"dialog.convert_project.create_copy": "Créer une copie",
	"dialog.texture.frame_time": "Temps d'une image",
	"dialog.texture.frame_time.desc": "Définit la durée pendant laquelle chaque image sera visible, en ticks. Chaque tick correspond à 1/20e de seconde.",
	"dialog.texture.frame_interpolate": "Interpoler",
	"dialog.texture.frame_interpolate.desc": "Interpoler entre les images de l'animation par un fondu enchaîné vers l'image suivante",
	"dialog.texture.frame_order_type": "Mode \"en boucle\"",
	"dialog.texture.frame_order_type.loop": "Boucle",
	"dialog.texture.frame_order_type.backwards": "Boucle à l'envers",
	"dialog.texture.frame_order_type.back_and_forth": "Va-et-vient",
	"dialog.texture.frame_order_type.custom": "Ordre personnalisé",
	"dialog.texture.frame_order": "Ordre des images",
	"dialog.texture.frame_order.desc": "Définissez un ordre de trame personnalisé en les listant dans un nouvel ordre. Le premier indice de trame commence à 0.",
	"dialog.select.mode": "Mode",
	"dialog.select.mode.new": "Nouvelle sélection",
	"dialog.select.mode.add": "Ajouter à la sélection",
	"dialog.select.mode.remove": "Retirer de la sélection",
	"dialog.select.mode.in_selection": "Sélectionner uniquement dans Selected",
	"dialog.predicate_overrides.model": "Modèle",
	"dialog.predicate_overrides.predicates": "Prédicats",
	"dialog.predicate_overrides.variants": "Variantes",
	"dialog.predicate_overrides.start_value": "Valeur de départ",
	"dialog.predicate_overrides.add_override": "Ajouter une surcharge",
	"dialog.predicate_overrides.add_predicate": "Ajouter un prédicat",
	"dialog.predicate_overrides.generate_overrides": "Générer des surcharges",
	"dialog.predicate_overrides.confirm_delete": "Êtes-vous sûr de vouloir supprimer toutes les surcharges ?",
	"dialog.predicate_overrides.predicate.angle": "Angle de la boussole",
	"dialog.predicate_overrides.predicate.blocking": "Bloque",
	"dialog.predicate_overrides.predicate.broken": "Est cassé",
	"dialog.predicate_overrides.predicate.cast": "Est coulé",
	"dialog.predicate_overrides.predicate.cooldown": "Rechargement",
	"dialog.predicate_overrides.predicate.damage": "Dégâts",
	"dialog.predicate_overrides.predicate.damaged": "Est endommagé",
	"dialog.predicate_overrides.predicate.lefthanded": "Positionné dans la main gauche",
	"dialog.predicate_overrides.predicate.pull": "Montant tiré",
	"dialog.predicate_overrides.predicate.pulling": "Tire",
	"dialog.predicate_overrides.predicate.charged": "Chargé",
	"dialog.predicate_overrides.predicate.firework": "A des feux d'artifice",
	"dialog.predicate_overrides.predicate.throwing": "Prêt à lancer",
	"dialog.predicate_overrides.predicate.time": "Heure de la journée",
	"dialog.predicate_overrides.predicate.custom_model_data": "Donnée de modèle personnalisées",
	"dialog.predicate_overrides.predicate.level": "Niveau de lumière",
	"dialog.predicate_overrides.predicate.filled": "Niveau de remplissage du sac",
	"dialog.predicate_overrides.predicate.tooting": "Sifflant",
	"settings.model_export_scale": "Échelle d'exportation du modèle",
	"settings.model_export_scale.desc": "Facteur par lequel l'échelle des modèles glTF, DAE et FBX exportés est réduite. La valeur par défaut est 16, ce qui convertit 16 unités Blockbench en 1 mètre dans l'exportation.",
	"action.export_fbx": "Exporter le modèle FBX",
	"action.export_fbx.desc": "Exporter le modèle et les animations au format fbx pour les utiliser dans d'autres applications 3D et moteurs de jeux.",
	"action.center_lateral": "Latéral central",
	"action.center_lateral.desc": "Centrer les éléments sélectionnés sur les axes X et Z",
	"action.adjust_opacity": "Ajuster l'opacité...",
	"action.adjust_opacity.desc": "Ajuster l'opacité de la texture sélectionnée",
	"action.rotate_texture_cw": "Faire tourner la texture dans le sens des aiguilles d'une montre",
	"action.rotate_texture_ccw": "Faire tourner la texture dans le sens inverse des aiguilles d'une montre",
	"action.predicate_overrides": "Modifier les surcharges des prédicats...",
	"action.predicate_overrides.desc": "Sélectionner des modèles pour remplacer ce modèle en fonction des conditions sélectionnées",
	"action.auto_set_cullfaces": "Définir automatiquement les Cullfaces",
	"action.auto_set_cullfaces.desc": "Génération automatique de cullfaces pour cacher les faces lorsqu'elles sont couvertes par le bloc voisin.",
	"menu.texture.edit_externally": "Editer en externe",
	"menu.mirror_painting.texture": "Éditeur de symétrie  2D",
	"menu.mirror_painting.texture.desc": "Permettre la peinture miroir dans l'espace 2D sur l'image ou la texture",
	"menu.animator.rotation_global": "Tourner dans l'espace global",
	"uv_editor.face_properties": "Propriétés des faces",
	"uv_editor.face_properties.material_instance": "Instance de matériau",
	"uv_editor.tint.info": "La teinte peut être activée sur une face pour dire à Minecraft de le teinter. De base, la teinte ne peut être utilisée que par des blocs spécifiques tels que les feuilles et la poussière de redstone, et ne peut avoir qu'une valeur de 0.",
	"uv_editor.cullface.info": "L'activation du cullface indique à une face du bloc de disparaître si un autre bloc plein est placé contre dans la direction spécifiée dans votre monde Minecraft. Ceci peut être utilisé pour optimiser les performances.",
	"uv_editor.material_instance.info": "Les instances de matériau peuvent être définies sur un nom défini par l'utilisateur. Ce nom peut être utilisé dans le fichier JSON de bloc du pack de comportement pour attribuer une texture et un matériau particuliers à la face.",
	"display.reference.frame_invisible": "Cadre (Invisible)",
	"data.settings_profile": "Profil",
	"message.display_skin.invalid_name": "Impossible de trouver un compte Minecraft portant le nom de \"%0\".",
	"dialog.load_plugins_from_query.title": "Charger des plugins",
	"dialog.load_plugins_from_query.text": "Vous avez utilisé un lien qui nécessite l'installation de plugins. Souhaitez-vous les installer ?",
	"dialog.select_model.title": "Sélectionner un modèle",
	"dialog.select_model.bones": "Os",
	"dialog.select_model.cubes": "Cubes",
	"dialog.settings.create_profile": "Créer un profil...",
	"settings_profile.confirm_delete": "Êtes-vous sûr de vouloir supprimer ce profil de paramètres?",
	"settings_profile.condition.type.selectable": "Sélectionnable manuellement",
	"settings.interface_mode": "Mode d'interface",
	"settings.interface_mode.desc": "Mode d'interface. Redémarrez Blockbench pour appliquer les modifications",
	"settings.interface_mode.auto": "Automatique",
	"settings.interface_mode.desktop": "Bureau",
	"settings.interface_mode.mobile": "Mobile",
	"settings.paint_through_transparency": "Peindre à travers la transparence",
	"settings.paint_through_transparency.desc": "Peindre à travers les pixels transparents lorsque le verrouillage du canal alpha est activé",
	"action.tab_overview": "Aperçu des onglets",
	"action.tab_overview.desc": "Afficher tous les onglets ouverts dans une grille et passer à un",
	"action.slider_color_red": "Couleur rouge",
	"action.slider_color_green": "Couleur verte",
	"action.slider_color_blue": "Couleur Bleu",
	"action.add_animation_controller": "Ajouter un contrôleur d'animation",
	"action.add_animation_controller.desc": "Créer un contrôleur d'animation vierge",
	"action.animation_controller_preview_mode": "Aperçu du contrôleur",
	"action.animation_controller_preview_mode.paused": "Mis en pause",
	"action.animation_controller_preview_mode.manual": "Prévisualisation manuelle",
	"action.animation_controller_preview_mode.play": "Lecture automatique",
	"action.keyframe_interpolation.bezier": "Bézier",
	"action.keyframe_bezier_linked": "Lier poignées de Bézier",
	"action.keyframe_bezier_linked.desc": "Connecte les poignées de Bézier des images clés droite et gauche",
	"action.reset_keyframe_handles": "Réinitialiser poignées images clés",
	"action.reset_keyframe_handles.desc": "Réinitialise les poignées de Bézier des images clés sélectionnées",
	"action.looped_animation_playback": "Lecture en boucle",
	"action.looped_animation_playback.desc": "Prévisualisez les animations dans une boucle infinie",
	"timeline.bind_to_actor": "Lier à l'acteur",
	"animation_controllers.select_preset": "Sélectionner un préréglage de contrôleur...",
	"animation_controllers.state.animations": "Animations",
	"animation_controllers.state.particles": "Particules",
	"animation_controllers.state.sounds": "Sons",
	"animation_controllers.state.on_entry": "En entrée",
	"animation_controllers.state.on_exit": "En sortie",
	"animation_controllers.state.transitions": "Transitions",
	"animation_controllers.state.condition": "Condition",
	"animation_controllers.state.blend_transition": "Temps de mélange",
	"animation_controllers.state.shortest_path": "Mélanger par chemin le plus court",
	"animation_controllers.state.edit_transition": "Modifier la transition",
	"menu.color_picker.picker_type": "Type de sélecteur",
	"menu.color_picker.picker_type.square": "Carré",
	"menu.color_picker.picker_type.wheel": "Roue",
	"menu.color_picker.slider_mode": "Mode curseur",
	"menu.color_picker.slider_mode.hsv": "Teinte, Saturation, Valeur",
	"menu.color_picker.slider_mode.rgb": "Rouge, Vert, Bleu",
	"menu.texture.render_mode.additive": "Additif",
	"panel.color.picker_options": "Options du sélecteur de couleurs",
	"panel.animation_controllers": "Contrôleur d'animation",
	"display.preset.armor_stand": "Sol (Porte-armure)",
	"data.file_path": "Chemin du fichier",
	"dialog.extrude.orientation": "Orientation",
	"dialog.extrude.orientation.upright": "Debout",
	"dialog.extrude.orientation.flat": "Plat",
	"dialog.scale.box_uv_warning": "La mise à l'échelle d'un modèle Encadrement UV peut casser les UV de votre modèle. À la place, essayez de redimensionner votre modèle avec un outil tiers, ou passez en mode UV par face dans Fichier → Projet…",
	"dialog.create_gif.format": "Format",
	"dialog.create_gif.format.gif": "GIF",
	"dialog.create_gif.format.png_sequence": "Séquence PNG",
	"dialog.create_gif.pixelate": "Pixéliser",
	"dialog.create_gif.bg_image": "Image d'arrière-plan",
	"dialog.create_gif.turn.desc": "Faites pivoter le modèle pendant l'enregistrement.  Utilisez des valeurs négatives pour faire tourner le modèle dans le sens des aiguilles d'une montre.  Une valeur de 60 correspond à une rotation toutes les secondes.",
	"settings_profile.condition": "Condition",
	"settings_profile.condition.type.file_path.desc": "Utilisez la syntaxe d'expression régulière pour faire correspondre le chemin d'accès au fichier du projet en cours.  Utiliser des barres obliques pour les répertoires",
	"settings.only_selected_bezier_handles": "Afficher uniquement les poignées de Bézier sélectionnées",
	"settings.only_selected_bezier_handles.desc": "Masque les poignées de Bézier des images clés qui ne sont pas actuellement sélectionnées",
	"settings.embed_textures": "Intégrer les textures",
	"settings.embed_textures.desc": "Intégrer le contenu des fichiers de texture dans les fichiers .bbmodel",
	"action.selection_mode.cluster": "Cluster",
	"dialog.copied_to_clipboard": "Copié dans le presse-papiers",
	"data.reference_image": "Image de référence",
	"message.delete_reference_image": "Êtes-vous sûr de vouloir supprimer cette image de référence ? Cette action est irréversible.",
	"message.add_reference_image.message": "Sélectionner l'endroit où charger l'image de référence",
	"message.add_reference_image.project": "Ajouter à ce projet",
	"message.add_reference_image.app": "Ajouter à tous les projets",
	"message.import_particle_texture.import": "Importer une texture de particule",
	"message.import_particle_texture.message": "Souhaitez-vous importer un fichier de texture à utiliser pour votre particule ?",
	"message.save_codec_selector.title": "Enregistrer le format du modèle",
	"message.save_codec_selector.message": "Sélectionnez un format pour enregistrer le modèle.",
	"message.save_codec_selector.project_file": "Projet Blockbench (.bbmodel)",
	"message.save_codec_selector.both": "Les deux",
	"message.display_skin.username": "Nom d'utilisateur (Java)",
	"message.palette_locked": "La palette est verrouillée",
	"dialog.project.default_uv_mode": "Mode UV par défaut",
	"dialog.project.default_uv_mode.description": "Le mode UV par défaut du projet. Le mode UV peut également être modifié par cube.",
	"dialog.export_options.title": "Options d'exportation",
	"dialog.edit_texture.preview": "Aperçu",
	"dialog.proportional_editing.range": "Plage",
	"dialog.proportional_editing.falloff": "Tomber",
	"dialog.proportional_editing.falloff.linear": "Linéaire",
	"dialog.proportional_editing.falloff.hermite_spline": "Lisse",
	"dialog.proportional_editing.falloff.constant": "Constant",
	"dialog.proportional_editing.selection": "Sélection",
	"dialog.proportional_editing.selection.linear": "Distance linéaire",
	"dialog.proportional_editing.selection.connections": "Connexions",
	"dialog.mirror_painting_texture_center.middle": "Milieu",
	"dialog.mirror_painting_texture_center.custom": "Personnaliser",
	"dialog.settings.reset_to_default": "Réinitialiser par défaut",
	"keybindings.item.num_slider.increase": "Augmenter",
	"keybindings.item.num_slider.decrease": "Diminuer",
	"settings.always_show_splash_art": "Toujours afficher Splash Art",
	"settings.always_show_splash_art.desc": "Toujours afficher le splash art sur l'écran de démarrage",
	"action.slider_palette_color": "Changer la couleur de la palette",
	"action.slider_palette_color.desc": "Faire défiler les couleurs de la palette",
	"action.proportional_editing": "Édition proportionnelle",
	"action.proportional_editing.desc": "Affecte proportionnellement les sommets environnants lors de la modification de parties d'un maillage",
	"action.limit_to_palette": "Limiter à la palette",
	"action.limit_to_palette.desc": "Limite les couleurs de la texture à celles de la palette actuellement chargée",
	"action.edit_reference_images": "Modifier les images de référence",
	"action.edit_reference_images.desc": "Activez le mode image de référence pour ajouter ou modifier des images de référence et des plans",
	"action.add_reference_image": "Ajouter une image de référence",
	"action.reference_image_from_clipboard": "Image de référence du presse-papier",
	"action.reference_image_list": "Images de référence",
	"action.connect_uv_faces": "Connecter les faces UV",
	"action.connect_uv_faces.desc": "Connecter les faces UV sélectionnées à la dernière face UV sélectionnée",
	"action.merge_uv_vertices": "Fusionner les sommets UV",
	"action.merge_uv_vertices.desc": "Accrocher les premiers sommets UV sélectionnés aux derniers sommets UV sélectionnés",
	"action.bedrock_animation_mode": "Mode d'Animation Bedrock",
	"action.bedrock_animation_mode.desc": "Sélectionnez le mode pour modifier les animations de Minecraft : Bedrock Edition dans",
	"action.bedrock_animation_mode.entity": "Entité",
	"action.bedrock_animation_mode.attachable_first": "Article 1ère Personne",
	"action.bedrock_animation_mode.attachable_third": "Article 3e Personne",
	"timeline.amplify": "Amplifier",
	"menu.options": "Options...",
	"menu.palette.lock_palette": "Verrouiller la palette",
	"menu.uv.export": "Exporter la cartographie UV",
	"menu.uv.flip_x": "Miroir X",
	"menu.uv.flip_y": "Miroir Y",
	"menu.mirror_painting.enabled": "Activer",
	"reference_image.position": "Position",
	"reference_image.size": "Taille",
	"reference_image.rotation": "Rotation",
	"reference_image.opacity": "Opacité",
	"reference_image.visibility": "Visibilité",
	"reference_image.clear_mode": "Effacer le Mode",
	"reference_image.layer": "Couche",
	"reference_image.layer.background": "Derrière le Modèle",
	"reference_image.layer.viewport": "Modèle ci-dessus",
	"reference_image.layer.float": "Au-dessus de l'interface",
	"reference_image.scope": "Portée",
	"reference_image.scope.project": "Seulement ce projet",
	"reference_image.scope.global": "Tous les projets",
	"reference_image.enabled_modes": "Activé dans les Modes",
	"codec.common.encoding": "Codage",
	"codec.common.armature": "Exporter des groupes en tant qu'armature",
	"codec.common.export_animations": "Exporter les animations",
	"codec.common.embed_textures": "Intégrer des textures",
	"preview.center_camera": "Caméra centrale",
	"display.reference.frame_top": "Article Haut du Cadre",
	"display.reference.frame_top_invisible": "Article Cadre supérieur (invisible)",
	"action.proportional_editing_range": "Plage d'édition proportionnelle",
	"action.proportional_editing_range.desc": "Ajuster la plage pour l'édition proportionnelle",
	"action.toggle_all_reference_images": "Cacher/Afficher toutes les images de référence",
	"action.toggle_all_reference_images.desc": "Afficher/Masquer toutes les images de référence en même temps",
	"action.add_animation_controller_state": "Ajouter l'état du contrôleur d'animation",
	"action.add_animation_controller_state.desc": "Ajouter un nouvel état au contrôleur d'animation",
	"menu.slider.round_value": "Valeur arrondie",
	"texture.error.too_large": "La résolution dépasse le maximum de %0",
	"dialog.copy_to_clipboard": "Copier dans le presse-papier",
	"dialog.open_url": "Ouvrir l'URL",
	"reference_image.image": "Image",
	"uv_editor.rotate_uv": "Rotation UV",
	"generic.error": "Erreur",
	"projects.start_screen": "Écran d'accueil",
	"message.invalid_link.message": "Le model partagé \"%0\" que vous essayez de charger et invalide ou a expiré.",
	"message.plugin_dependencies.title": "Dépendances du plugin",
	"message.plugin_dependencies.message1": "Le plugin requiert ces dépendances :",
	"message.plugin_dependencies.message1_update": "Le plugin %0 a été mis à jour et requiert désormais ces dépendances :",
	"message.plugin_dependencies.message2": "Souhaitez-vous les installer pour continuer ?",
	"message.plugin_dependencies.invalid": "Malheureusement le plugin ne peux pas être installé, due à une dépendance invalide :",
	"message.preview_scene_load_failed": "Echec du chargement de la scène de prévisualisation. Vérifiez votre connexion internet.",
	"dialog.convert_project.text1": "Convertir le projet dans un autre format.",
	"dialog.convert_project.text2": "La conversion se fait à vos risques et périls. Les formats ont des caractéristiques et des restrictions différentes, de sorte que la conversion peut, dans certains cas, casser certaines parties de votre projet.",
	"dialog.convert_project.text3": "Vous ne pouvez pas annuler une conversion, c'est la raison pour laquelle, par défaut, une copie est crée.",
	"dialog.unsaved_work.title": "Travail non sauvegardé",
	"dialog.unsaved_work.text": "Le projet en cours contiens des modifications non sauvegardées. Voulez-vous sauvegarder ces changements ?",
	"dialog.unsaved_work.discard_all": "Tout rejeter",
	"dialog.unsaved_work.save_all": "Tout sauvegarder",
	"dialog.resize_texture.mode": "Mode",
	"dialog.resize_texture.mode.crop": "Recadrer/Étendre",
	"dialog.resize_texture.mode.scale": "Échelle",
	"dialog.plugins.is_installed": "Installé",
	"dialog.plugins.is_disabled": "Désactivé",
	"dialog.plugins.disable": "Désactiver",
	"dialog.plugins.enable": "Activer",
	"dialog.plugins.dependencies": "Dépend de :",
	"dialog.view_backups.open_folder": "Ouvrir le dossier",
	"dialog.share_model.reference_images": "Inclure les images de référence",
	"dialog.share_model.too_large": "Echec de l'envoi : Model trop volumineux",
	"dialog.share_model.too_large_references": "Echec de l'envoi : Model trop volumineux. Essayez sans les images de références.",
	"settings.stretch_linked": "Lien d'étirement",
	"settings.stretch_linked.desc": "Etirer le cube dans toutes les directions avec la même valeur",
	"settings.grids": "Afficher les grilles",
	"settings.grids.desc": "Montrer ou cacher toutes les grilles 3D",
	"settings.double_click_switch_tools": "Changer d'outil avec un double clique",
	"settings.double_click_switch_tools.desc": "Double clique sur la vue pour changer d'outil",
	"settings.outlines_in_paint_mode": "Contours de sélection en mode peinture",
	"settings.outlines_in_paint_mode.desc": "Affichage des contours de sélection des éléments en mode peinture",
	"settings.json_indentation": "Indentation JSON",
	"settings.json_indentation.desc": "Style d'indentation pour les fichiers JSON exportés",
	"settings.json_indentation.tabs": "Tabs",
	"settings.json_indentation.spaces_4": "Espaces : 4",
	"settings.json_indentation.spaces_2": "Espaces : 2",
	"action.slider_stretch": "Etirement",
	"action.slider_stretch.desc": "Etire les cubes de façon multiplicative sur l'axe %0 sans changer les UV",
	"action.view_backups": "Voir les sauvegardes",
	"action.view_backups.desc": "Parcourir la liste des sauvegardes automatiques de projets",
	"action.search_outliner": "Rechercher une liste",
	"action.search_outliner.desc": "Rechercher des noms d'éléments spécifiques dans la liste",
	"action.mirror_modeling": "Modélisation en miroir",
	"action.mirror_modeling.desc": "Activer la modélisation en miroir sur l'axe X. Tous les changements effectués dans la fenêtre de visualisation seront répercutés de l'autre côté, sauf s'ils sont spécifiquement désactivés dans l'élément.",
	"action.allow_element_mirror_modeling": "Autorisé la modélisation en miroir",
	"action.allow_element_mirror_modeling.desc": "Choisir si les éléments sélectionnés peuvent être affectés par la modélisation en miroir",
	"action.switch_face_crease": "Changer le pli de la face",
	"action.switch_face_crease.desc": "Changement du sens de pliage du quadrilatère au milieu",
	"action.clear_unused_texture_space": "Effacer les espaces non utiliser de la texture",
	"action.clear_unused_texture_space.desc": "Effacer les parties de la texture qui ne sont associées à aucun élément par la cartographie UV",
	"action.split_screen": "Séparer l'écran",
	"action.split_screen.desc": "Sélectionner un mode d'écran partagé",
	"action.split_screen.single": "Seul",
	"action.split_screen.double_horizontal": "Double horizontal",
	"action.split_screen.double_vertical": "Double vertical",
	"action.split_screen.quad": "Quadruple",
	"action.split_screen.triple_left": "Triple gauche",
	"action.split_screen.triple_right": "Triple droit",
	"action.split_screen.triple_top": "Triple haut",
	"action.split_screen.triple_bottom": "Triple bas",
	"action.uv_project_from_view": "Projet UV à partir de la vue",
	"action.uv_project_from_view.desc": "Générer automatiquement des UV pour les faces sélectionnées à partir de la perspective de la vue 3D",
	"action.graph_editor_other_graphs": "Afficher les autres graphiques",
	"action.graph_editor_other_graphs.desc": "Affichage ou non des graphiques des axes non sélectionnés",
	"action.graph_editor_include_other_graphs": "Inclure d'autres graphiques",
	"action.graph_editor_include_other_graphs.desc": "Si l'éditeur de graphiques inclut les graphiques qui ne sont pas sélectionnés dans la vue",
	"action.set_ik_source": "Définir la racine IK",
	"action.set_ik_source.desc": "Sélectionner l'os racine de la chaîne qui doit être déplacé par cet objet null via la cinématique inverse",
	"edit.loop_cut.cuts": "Coupes",
	"panel.element.stretch": "Étirer",
	"preview_scene.minecraft_plains": "Plaines",
	"preview_scene.minecraft_cherry_grove": "Bois de cerisier",
	"preview_scene.minecraft_snowy_tundra": "Toundra enneigée",
	"preview_scene.minecraft_sunset": "Coucher de soleil",
	"preview_scene.minecraft_night": "Nuit",
	"preview_scene.minecraft_desert": "Désert",
	"preview_scene.minecraft_underwater": "Sous l'eau",
	"preview_scene.minecraft_coral_reef": "Récif de Corail",
	"preview_scene.minecraft_lush_cave": "Cavernes luxuriantes",
	"preview_scene.minecraft_deep_dark": "Abîmes",
	"generic.navigate_forward": "Avant",
	"generic.navigate_back": "Arrière",
	"action.element_render_order": "Ordre de rendu de la transparence",
	"action.element_render_order.default": "Auto",
	"action.element_render_order.behind": "Derrière",
	"action.element_render_order.in_front": "Devant",
	"message.installing_update.title": "Mise à jour disponible",
	"message.installing_update.message": "Une nouvelle version est prête à être installée. Après la fermeture de l'application, merci de laisser environ %0 secondes avant de rouvrir Blockbench ou d'éteindre votre ordinateur afin que la mise à jour soit installée.",
	"settings.brush_cursor_2d": "Curseur pinceau 2D",
	"settings.brush_cursor_2d.desc": "Afficher un contour autour du pinceau dans l'espace de travail 2D",
	"settings.brush_cursor_3d": "Curseur pinceau 3D",
	"settings.brush_cursor_3d.desc": "Afficher un contour autour du pinceau dans l'espace de travail 3D",
	"settings.cdn_mirror": "Utiliser le miroir CDN",
	"settings.cdn_mirror.desc": "Utilisez le CDN miroir pour télécharger les plugins. Le miroir reçoit les mises à jour plus rapidement et fonctionne dans certaines régions où le CDN par défaut ne fonctionne pas.",
	"data.layer": "Calque",
	"data.panel": "Panel",
	"generic.confirm_delete": "Êtes-vous sûr de vouloir supprimer ceci ?",
	"format_category.general": "Général",
	"modifier_actions.no_uniform_scaling": "Free Scaling",
	"message.texture_refresh_conflict.title": "Conflicting Texture Versions",
	"message.texture_refresh_conflict.message": "The texture file might contain changes that conflict with Blockbench's version",
	"message.texture_refresh_conflict.keep_ours": "Keep Blockbench's version",
	"message.texture_refresh_conflict.keep_theirs": "Load file and discard all changes and layers in Blockbench",
	"message.group_required_to_animate": "You cannot animate this type of element. Create a group or armature to animate it.",
	"dialog.texture.uv_size": "UV Size",
	"dialog.advanced_screenshot.angle_preset": "Angle Preset",
	"dialog.advanced_screenshot.resolution": "Résolution",
	"dialog.advanced_screenshot.zoom_to_fit": "Zoomer pour ajuster",
	"dialog.advanced_screenshot.zoom": "Zoom / Focal Length",
	"dialog.advanced_screenshot.anti_aliasing": "Anti-aliasing",
	"dialog.advanced_screenshot.anti_aliasing.off": "Off",
	"dialog.advanced_screenshot.anti_aliasing.msaa": "Multisampling",
	"dialog.advanced_screenshot.anti_aliasing.ssaa": "Supersampling",
	"dialog.advanced_screenshot.show_gizmos": "Show Edit Gizmos",
	"dialog.advanced_screenshot.shading": "Shading",
	"settings.auto_keyframe": "Auto Keyframe",
	"settings.auto_keyframe.desc": "Automatically create a keyframe with default values at the timeline start when transforming the bone at a later point",
	"settings.modded_entity_integer_size": "Modded Entity Integer Size",
	"settings.modded_entity_integer_size.desc": "Limit cube sizes in the Modded Entity format to integers. While floats are technically supported in some versions, integers are much easier to UV-map.",
	"category.layers": "Calques",
	"keybind.paint_secondary_color": "Paint with Secondary Color",
	"action.selection_tool_operation_mode": "Selection Operation Mode",
	"action.selection_tool_operation_mode.create": "Nouvelle sélection",
	"action.selection_tool_operation_mode.add": "Ajouter à la sélection",
	"action.selection_tool_operation_mode.subtract": "Soustraire à la sélection",
	"action.selection_tool_operation_mode.intersect": "Intersect",
	"action.pixel_perfect_drawing": "Pixel Perfect Drawing",
	"action.pixel_perfect_drawing.desc": "Draw smooth pixel-art lines without double pixels at curves",
	"action.selection_tool": "Outil de sélection",
	"action.selection_tool.desc": "Select parts of the image",
	"action.selection_tool.rectangle": "Rectangle",
	"action.selection_tool.ellipse": "Ellipse",
	"action.selection_tool.lasso": "Lasso Select",
	"action.selection_tool.wand": "Baguette magique",
	"action.selection_tool.color": "Même couleur",
	"action.move_layer_tool": "Déplacer le calque",
	"action.move_layer_tool.desc": "Move the current layer or selection",
	"action.export_modded_animations": "Export Modded Entity Animations",
	"action.export_modded_animations.desc": "Export animations for a Minecraft Java Edition modded entity model",
	"action.swap_colors": "Échanger les couleurs",
	"action.swap_colors.desc": "Swap the main color with the secondary color",
	"action.apply_mesh_rotation": "Appliquer une rotation",
	"action.apply_mesh_rotation.desc": "Reset the element rotation of the mesh, and apply it to the geometry instead",
	"action.flip_texture_x.desc": "Flip the texture or layer horizontally",
	"action.flip_texture_y.desc": "Flip the texture or layer vertically",
	"action.rotate_texture_cw.desc": "Rotate the texture or layer clockwise",
	"action.rotate_texture_ccw.desc": "Rotate the texture or layer counter-clockwise",
	"action.crop_texture_to_selection": "Recadrer la texture à la sélection",
	"action.create_empty_layer": "Créer un calque vide",
	"action.enable_texture_layers": "Activer les calques",
	"action.disable_texture_layers": "Désactiver les calques",
	"action.layer_opacity": "Opacité du calque",
	"action.layer_to_texture_size": "Agrandir le calque à la taille de la texture",
	"action.layer_to_texture_size.desc": "Expand the layer to the size of the texture",
	"action.merge_layer_down": "Merge Down",
	"action.merge_layer_down.desc": "Merge into the layer below",
	"action.advanced_screenshot": "Advanced Screenshot...",
	"action.advanced_screenshot.desc": "Faire une capture d'écran du modèle avec des options avancées",
	"action.bake_ik_animation": "Bake Inverse Kinematics",
	"action.bake_ik_animation.desc": "Bake the rotations applied by inverse kinematics into the selected animation",
	"action.save_animation_preset": "Save Animation Preset...",
	"action.save_animation_preset.desc": "Save the selected keyframes as an animation preset",
	"action.animation_onion_skin": "Animation Onion Skin",
	"action.animation_onion_skin.desc": "Display an wireframe view of a different frame in the animation for reference",
	"action.apply_animation_preset": "Apply Animation Preset",
	"action.apply_animation_preset.desc": "Select from a list of animation presets and apply it to the selected bone",
	"menu.brush_presets.pixel_perfect": "Pixel-perfect Brush",
	"panel.layers": "Calques",
	"uv_editor.copy_paste_tool.to_layer": "To New Layer",
	"format.image.new": "Créer une nouvelle image",
	"format.image.info.summary": "The 2D Image editor lets you create and edit images and pixel art directly in Blockbench, without the need for an external image editor. Edit images, modify textures, or create your own pixel art!",
	"settings.move_with_selection_tool": "Use Selection Tool to Move Selections",
	"settings.move_with_selection_tool.desc": "Allow the Selection Tool to directly move selections, without having to switch to the Move Layer tool",
	"settings.final_newline": "Final Newline",
	"settings.final_newline.desc": "Insert a newline character at the end of exported files",
	"action.crop_layer_to_selection": "Crop Layer to Selection",
	"action.edit_mode_uv_overlay.desc": "Display the UV map overlay for all elements in edit mode",
	"menu.image": "Image",
	"menu.texture.discard_changes": "Discard Changes",
	"menu.texture.discard_changes.desc": "Discard all unsaved changes and load the latest version from the file",
	"panel.textures.images": "Images",
	"dialog.advanced": "Advanced",
	"dialog.recommended_option": "recommended",
	"modifier_actions.snap_to_center": "Snap to Center",
	"modifier_actions.snap_to_pixels": "Snap to Pixels",
	"message.invalid_format.install_plugin": "Install plugin '%0'",
	"message.plugin_deprecated.message": "Are you sure you want to install this deprecated plugin?",
	"message.plugin_deprecated.install_anyway": "Install Anyway",
	"message.image_editor.not_found": "Could not find the selected image editor. Please select a different option.",
	"message.knife_tool.confirm": "Press %0 or click here to apply Knife Tool",
	"message.knife_tool.skipped_face": "Cannot cut between different faces. Include the edges or vertices between them!",
	"message.optimize_animation.keyframes_removed": "Removed %0 redundant keyframes",
	"message.optimize_animation.nothing_to_optimize": "Found nothing to optimize!",
	"message.duplicate_bone_copy_animation.title": "Copy Animation",
	"message.duplicate_bone_copy_animation.message": "The duplicated bone is animated in %0 animations. Do you want to copy the keyframes over to the new bone?",
	"message.auto_fix_mesh_edit.title": "Auto Fix",
	"message.auto_fix_mesh_edit.revert": "Revert Edit",
	"message.auto_fix_mesh_edit.overlapping_vertices": "Certain vertices have been moved into the same spot. How would you like to proceed?",
	"message.auto_fix_mesh_edit.concave_quads": "One or more quad faces are now concave, which can cause issues in UV-mapping and rendering. Blockbench can automatically fix it for you:",
	"message.auto_fix_mesh_edit.merge_vertices": "Merge Vertices",
	"message.auto_fix_mesh_edit.split_quads": "Split Quads",
	"message.load_images.add_image": "Add Image",
	"dialog.project.modded_entity_entity_class": "Entity Class",
	"dialog.resize_texture.offset": "Offset",
	"dialog.animated_texture_editor.code_reference": "Code Reference",
	"dialog.animated_texture_editor.code_reference.about": "This code to implement the texture animation was generated as a reference and does not necessarily work without modification. Check out the documentation to learn more.",
	"dialog.animated_texture_editor.code_reference.docs": "Documentation",
	"dialog.animated_texture_editor.reframe": "Reframe",
	"dialog.animated_texture_editor.stride": "Frame Size",
	"dialog.animated_texture_editor.frames": "Number of Frames",
	"dialog.animated_texture_editor.add_frame": "Add Frame",
	"dialog.animated_texture_editor.resize_frames": "Resize Frames...",
	"dialog.animated_texture_editor.apply": "Apply",
	"dialog.add_primitive.edge_size": "Edge Size",
	"dialog.change_animation_speed.speed": "Speed",
	"dialog.change_animation_speed.adjust_snapping": "Adjust Snapping",
	"dialog.optimize_animation.selection": "Selection",
	"dialog.optimize_animation.selection.selected_keyframes": "Selected Keyframes",
	"dialog.optimize_animation.selection.selected_animation": "Selected Animation",
	"dialog.optimize_animation.selection.all_animations": "All Animations",
	"dialog.optimize_animation.thresholds": "Threshold values",
	"dialog.import_obj.obj": "OBJ File",
	"dialog.import_obj.mtl": "MTL File",
	"dialog.import_obj.scale": "Scale",
	"layout.thumbnail": "Custom Thumbnail CSS",
	"settings.pixel_grid": "Pixel Grid",
	"settings.pixel_grid.desc": "Show texture pixel grid on elements in edit mode",
	"settings.image_editor_grid_size": "Image Editor Grid Size",
	"settings.image_editor_grid_size.desc": "Size of the large grid in the 2D image editor",
	"settings.ground_plane_double_side": "Ground Plane Double-sided",
	"settings.ground_plane_double_side.desc": "Make the ground plane visible from below",
	"settings.optifine_save_default_texture": "OptiFine JEM: Export selected texture",
	"settings.optifine_save_default_texture.desc": "Export the selected texture as the default texture of the model",
	"action.slider_color_select_threshold": "Color Select Threshold",
	"action.slider_color_select_threshold.desc": "How close the color of a neighboring pixel has to be to get selected by color or wand select",
	"action.stretch_tool": "Stretch",
	"action.stretch_tool.desc": "Tool to select and stretch elements",
	"action.knife_tool": "Knife Tool",
	"action.knife_tool.desc": "Tool to cut mesh faces into smaller pieces",
	"action.duplicate_project": "Duplicate Project",
	"action.duplicate_project.desc": "Creates a copy of the open project",
	"action.transform_space.parent": "Parent",
	"action.transform_pivot_space": "Pivot Transform Space",
	"action.solidify_mesh_selection": "Solidify Faces",
	"action.solidify_mesh_selection.desc": "Solidify the selected faces of the mesh",
	"action.animated_texture_editor": "Flipbook Editor...",
	"action.animated_texture_editor.desc": "Edit the flipbook animation of the selected texture",
	"action.center_individual_pivots": "Center Individual Pivots",
	"action.center_individual_pivots.desc": "Set the pivot point of each selected element to its center",
	"action.uv_cycle": "Cycle UV",
	"action.uv_cycle.desc": "Cycle through the order of UV vertices without changing the UV positions",
	"action.uv_cycle_invert": "Cycle Invert UV",
	"action.uv_cycle_invert.desc": "Reverse the order of UV vertices without changing the UV positions",
	"action.slider_animation_controller_speed": "Controller Playback Speed",
	"action.slider_animation_controller_speed.desc": "The playback speed of animation controllers in percent",
	"action.optimize_animation": "Optimize Animation",
	"action.optimize_animation.desc": "Optimize the current animation and reduce the keyframe count",
	"action.change_animation_speed": "Change Animation Speed...",
	"action.change_animation_speed.desc": "Change the speed of the selected animation",
	"timeline.select_particle_file": "Select Particle File",
	"timeline.select_sound_file": "Select Sound File",
	"menu.cube.texture.default": "Default",
	"menu.texture.particle.clear": "Stop using for Particles",
	"menu.texture.use_as_default": "Set as Default",
	"menu.texture.use_as_default.clear": "Unassign as Default",
	"menu.toolbar.overflow": "Toolbar Overflow",
	"edit.solidify_mesh_selection.thickness": "Thickness",
	"reference_image.sync_to_timeline": "Sync To Timeline",
	"reference_image.toggle_playback": "Play/Pause",
	"dialog.add_primitive.shape.beveled_cuboid": "Beveled Cuboid",
	"dialog.ignore_all": "Ignore All",
	"data.texture_group": "Texture Group",
	"data.animation": "Animation",
	"generic.on": "On",
	"generic.off": "Off",
	"format.free.info.3d_printing": "3D Printing",
	"message.invalid_file.merge_conflict": "The file contains unresolved Git merge conflicts.",
	"dialog.expand_texture_selection.radius": "Amount",
	"dialog.expand_texture_selection.corner": "Corner Shape",
	"dialog.expand_texture_selection.corner.round": "Round",
	"dialog.expand_texture_selection.corner.square": "Square",
	"dialog.expand_texture_selection.corner.manhattan": "Manhattan",
	"dialog.merge_animation.merge_target": "Merge into",
	"keybindings.variation_conflict": "Variation conflicts with the main keybinding",
	"settings.recovery_save_interval": "Recovery Point Save Interval",
	"settings.recovery_save_interval.desc": "Blockbench regularly saves the open project in the background to recover in case of a computer crash. Set the interval in seconds. Set to 0 to disable saving.",
	"settings.save_view_per_tab": "Save View per Tab",
	"settings.save_view_per_tab.desc": "Save the current view angle for each tab separately",
	"settings.inherit_parent_color": "Inherit Parent Color",
	"settings.inherit_parent_color.desc": "Set the marker color of a newly created element to the color of the parent instead of a random color",
	"keybind.preview_select.multi_select": "Multi-select",
	"keybind.preview_select.group_select": "Group-select",
	"keybind.preview_select.loop_select": "Loop-select",
	"action.fill_mode.selection": "Selection",
	"action.fill_mode.selected_elements": "Selected Elements",
	"action.image_tiled_view": "Tiled View",
	"action.image_tiled_view.description": "Enable the tiled view in the 2D editor",
	"action.image_onion_skin_view": "Image Editor Onion Skin",
	"action.image_onion_skin_view.description": "Enable the onion skin view in the 2D editor",
	"action.expand_texture_selection": "Expand Texture Selection",
	"action.expand_texture_selection.desc": "Expand or shrink the texture selection",
	"action.switch_tabs.reverse_order": "Reverse order",
	"action.save_project_incremental": "Save Project With Increment",
	"action.save_project_incremental.desc": "Saves the current model as a project file with an increment (ex: project_2.bbmodel)",
	"action.copy.multiple": "Copy All",
	"action.copy.multiple.desc": "Copy all available data individually",
	"action.paste.multiple": "Paste All",
	"action.randomize_marker_colors": "Randomize Marker Colors",
	"action.cube_light_emission": "Light Emission",
	"action.cube_light_emission.desc": "Change the emissiveness of the selected cubes, as a value between 0 and 15",
	"action.view_mode.colored_solid": "Solid with Marker Colors",
	"action.focus_on_selection.rotate_only": "Rotate only",
	"action.create_texture_group": "Create Texture Group",
	"action.create_texture_group.desc": "Create a group for your textures",
	"action.uv_maximize.all_faces": "Affect all faces",
	"action.retarget_animators": "Retarget Animations",
	"action.retarget_animators.desc": "Select which animator targets which bone or element",
	"action.merge_animation": "Merge Animation",
	"action.merge_animation.desc": "Merge the animation into another animation",
	"action.add_keyframe.reset_values": "With default values",
	"action.set_timeline_range_start": "Set Timeline Range Start",
	"action.set_timeline_range_start.desc": "Set the start point for a custom playback range in the animation timeline",
	"action.set_timeline_range_end": "Set Timeline Range End",
	"action.set_timeline_range_end.desc": "Set the end point for a custom playback range in the animation timeline",
	"action.disable_timeline_range": "Disable Timeline Range",
	"action.disable_timeline_range.desc": "Disable the custom playback range in the animation timeline",
	"menu.texture_group.resolve": "Resolve",
	"menu.image_tiled_view.mirrored": "Mirrored Edges",
	"menu.image_onion_skin_view.frame": "Frames",
	"menu.image_onion_skin_view.frame.last_viewed": "Last Viewed Frame",
	"menu.image_onion_skin_view.frame.previous": "Previous Frame",
	"menu.image_onion_skin_view.frame.next": "Next Frame",
	"menu.image_onion_skin_view.frame.both": "Previous + Next",
	"menu.image_onion_skin_view.display": "Display",
	"menu.image_onion_skin_view.display.pixels": "Smaller Pixels",
	"menu.image_onion_skin_view.display.transparent": "Transparent",
	"menu.image_onion_skin_view.above": "Display Above",
	"menu.animation.reload": "Reload",
	"switches.autouv.alt": "Relative",
	"display.rotation_pivot": "Rotation Pivot",
	"display.scale_pivot": "Scale Pivot",
	"display.reference.fox": "Fox",
	"display.reference.eating": "Eating",
	"preview_scene.sky": "Sky",
	"preview_scene.space": "Space",
	"preview_scene.minecraft_ocean": "Ocean",
	"message.import_palette.selection_only": "Selection only",
	"dialog.blend_transition_edit.ease_in_out": "Ease-in-out (%0)",
	"dialog.blend_transition_edit.generate": "Generate...",
	"dialog.blend_transition_edit.generate.learn_more": "More info and preview",
	"dialog.blend_transition_edit.generate.curve": "Easing Type",
	"dialog.blend_transition_edit.generate.steps": "Keyframes",
	"settings.fps_limit": "FPS Limit",
	"settings.fps_limit.desc": "Limit how many frames per second Blockbench renders. The actual frame rate is limited to what your device can display.",
	"settings.outliner_reveal_on_select": "Reveal Elements on Select",
	"settings.outliner_reveal_on_select.desc": "Reveal elements in the ouliner when selected",
	"settings.java_export_pivots": "Export Pivots in Java block/item models",
	"settings.java_export_pivots.desc": "Save pivot points in Java block/item models on cubes without rotation",
	"animation_controllers.state.blend_transition_curve": "Blend Transition Curve",
	"menu.slider.reset_vector": "Reset Vector",
	"dialog.blend_transition_edit.extended": "Extended Graph",
	"message.screenshot_too_large.title": "Screenshot Resolution Issue",
	"message.screenshot_too_large.message": "The screenshot could not be rendered successfully. Please try again with a lower resolution or without supersampling.",
	"message.rename_elements.numbering": "You can use special characters to generate sequential numbers: % to get the index of the element within its group, $ to get the index within the selection.",
	"generic.edit_externally": "Edit Externally",
	"message.settings_require_restart.title": "Restart Required",
	"message.settings_require_restart.message": "Some settings will only apply after restarting the program.",
	"message.settings_require_restart.restart_now": "Restart Now",
	"message.settings_require_restart.restart_later": "Restart Later",
	"message.classroom_mode.install_plugin": "Cannot install plugins in Classroom Mode",
	"dialog.collection.export_path": "Export Path",
	"dialog.collection.select_all": "Select All",
	"dialog.collection.select_none": "Select None",
	"dialog.collection.add_with_filter": "Add with Filter",
	"dialog.collection.remove": "Remove",
	"dialog.material_config.title": "Material Config",
	"dialog.material_config.color_value": "Color Value",
	"dialog.material_config.mer": "Metal-Emissive-Roughness",
	"dialog.material_config.mer_value": "MER Value",
	"dialog.material_config.depth_type": "Depth Type",
	"dialog.create_texture.disable_mirror_uv": "Disable UV Mirroring",
	"dialog.create_texture.disable_mirror_uv.desc": "Disable the UV Mirror option in Mirror Modeling to preserve separate UVs for each side of the model",
	"dialog.create_gif.turn.sync_to_anim_length": "Sync to animation length",
	"settings.category.controls": "Controls",
	"settings.classroom_mode": "Classroom Mode",
	"settings.classroom_mode.desc": "Restricts functionality such as installing plugins and removes links to social media",
	"settings.antialiasing_bleed_fix": "Fix anti-aliasing bleeding",
	"settings.antialiasing_bleed_fix.desc": "Fixes texture bleeding when using anti-aliasing. Potentially unsupported on older hardware.",
	"settings.tone_mapping": "Tone Mapping",
	"settings.tone_mapping.desc": "Approximation method for displaying high dynamic range on a standard screen for PBR rendering.",
	"settings.audio_scrubbing": "Timline Scrubbing Audio",
	"settings.audio_scrubbing.desc": "Play short previews of the audio while scrubbing through time timeline",
	"settings.viewport_rotate_speed": "Viewport Rotate Speed",
	"settings.viewport_rotate_speed.desc": "Input sensitivity when rotating in the viewport",
	"settings.viewport_zoom_speed": "Viewport Zoom Speed",
	"settings.viewport_zoom_speed.desc": "Input sensitivity when zooming in the viewport",
	"settings.editor_2d_zoom_speed": "2D Editor Zoom Speed",
	"settings.editor_2d_zoom_speed.desc": "Input sensitivity when zooming in the UV and 2D paint editor",
	"category.select": "Select",
	"action.vertex_snap_mode.rotate": "Rotate",
	"action.export_image": "Export Image",
	"action.export_image.desc": "Export your texture as an image file",
	"action.apply_mirror_modeling": "Apply Mirror Modeling",
	"action.apply_mirror_modeling.desc": "Apply Mirror Modeling to the selection. All selected elements will be copied and flipped across the X axis.",
	"action.create_collection": "Create Collection",
	"action.create_collection.desc": "Create a collection out of the outliner selection",
	"action.set_collection_content_to_selection": "Set Collection Content to Selected",
	"action.set_collection_content_to_selection.desc": "Set the selected groups and elements as the content of the collection",
	"action.add_to_collection": "Add Selected to Collection",
	"action.add_to_collection.desc": "Add the selected groups and elements to the collection",
	"action.view_mode.material": "Material Preview",
	"action.create_material": "Create Material",
	"action.create_material.desc": "Create a new PBR material out of the selected texture",
	"action.generate_pbr_map": "Generate PBR Map...",
	"action.generate_pbr_map.desc": "Generate a PBR map (height map or metalness, emissiveness, roughness) from an existing texture",
	"menu.tools.main_tools": "Toolbox",
	"menu.view.panels": "Panels",
	"menu.texture.pbr_channel": "PBR Channel",
	"menu.texture.pbr_channel.color": "Color",
	"menu.texture.pbr_channel.normal": "Normal",
	"menu.texture.pbr_channel.height": "Height",
	"menu.texture.pbr_channel.mer": "MER (Metalness-Emissive-Roughness)",
	"menu.texture.pbr_channel.mer_subsurface": "MER Subsurface",
	"menu.collection.export_project": "Export Project",
	"menu.collection.export_as": "Export as \"%0\"",
	"menu.panel.enable": "Enable",
	"menu.panel.move_to": "Move To",
	"menu.panel.move_to.left_bar": "Left Sidebar",
	"menu.panel.move_to.right_bar": "Right Sidebar",
	"menu.panel.move_to.top": "Top",
	"menu.panel.move_to.bottom": "Bottom",
	"menu.panel.move_to.float": "Float",
	"menu.panel.move_to.hidden": "Hide",
	"menu.panel.fold": "Collapse",
	"menu.mirror_painting.texture_center": "Origin",
	"menu.mirror_modeling.mirror_uv": "Mirror UV",
	"menu.animation_onion_skin.frames": "Frames",
	"menu.animation_onion_skin.select": "Select",
	"menu.animation_onion_skin.previous": "Previous",
	"menu.animation_onion_skin.next": "Next",
	"menu.animation_onion_skin.previous_next": "Previous + Next",
	"menu.animation_onion_skin.count": "Count",
	"menu.animation_onion_skin.interval": "Interval",
	"menu.animation_onion_skin_selective": "Selective Onion Skin",
	"menu.animation_onion_skin_selective.desc": "Only display onion skin for the selected part of the model",
	"edit.loop_cut.unit": "Unit",
	"edit.loop_cut.unit.size_units": "Size Units",
	"edit.loop_cut.unit.percent": "Percent",
	"edit.extrude_mesh_selection.direction": "Direction",
	"edit.extrude_mesh_selection.direction.outwards": "Outwards",
	"edit.extrude_mesh_selection.direction.average": "Average",
	"edit.extrude_mesh_selection.even_extend": "Even Extend",
	"edit.vertex_snap.align": "Align",
	"edit.vertex_snap.align.longest": "Longest Axis",
	"edit.vertex_snap.align.direction": "Direction from Pivot",
	"edit.vertex_snap.align.align_axis": "%0 Axis",
	"edit.vertex_snap.ignore_axis": "Ignore Axis",
	"codec.common.format": "Format",
	"codec.image.quality": "Quality",
	"panel.collections": "Collections",
	"modifier_actions.always": "Always Enabled",
	"modifier_actions.unless": "Unless %0",
	"settings.undo_selections": "Undo Selection",
	"settings.undo_selections.desc": "Track selection changes as a step in the undo history",
	"action.focus_on_selection.zoom": "Zoom to fit",
	"display.reference.tooting": "Horn Tooting",
	"settings.selection_tolerance": "Selection Tolerance",
	"settings.selection_tolerance.desc": "Size of the area that can be clicked to select an edge or vertex",
	"action.delete.keep_vertices": "Keep Edges/Vertices",
	"menu.mesh": "Mesh",
	"dialog.material_config.subsurface": "Subsurface Scattering",
	"dialog.material_config.subsurface_enabled.desc": "Use the MER map alpha channel for subsurface scattering",
	"settings.pick_combined_color": "Pick Combined Color",
	"settings.pick_combined_color.desc": "Pick the combined color of all layers at the respective pixel, instead of the color on the active layer",
	"action.split_rgb_into_layers": "Split RGBA Channels into Layers",
	"action.split_rgb_into_layers.desc": "Split the texture into additive layers, one for each RGBA channel",
	"dialog.project.java_block_version": "Format Version",
	"data.spline_mesh": "Courbe",
	"data.billboard": "Billboard",
	"data.armature": "Armature",
	"data.armature_bone": "Armature Bone",
	"generic.reload": "Reload",
	"modifier_actions.subtract": "Subtract",
	"modifier_actions.reduced_intensity": "Fine-Tune",
	"modifier_actions.select_bone": "Select Bone",
	"modifier_actions.spline_select_multiple_points": "Sélectionner plusieurs Points ou Poignées",
	"modifier_actions.move_panel_without_docking": "Move without docking",
	"message.save_all_textures.message": "Do you want to save each of the following textures?",
	"message.save_all_textures.skip": "Skip",
	"dialog.add_spline.shape": "Forme",
	"dialog.add_spline.shape.segment": "Segment",
	"dialog.add_spline.shape.square": "Rectangle",
	"dialog.add_spline.shape.circle": "Cercle",
	"dialog.add_spline.diameter": "Diamètre",
	"dialog.add_spline.sides_tubular": "Segments Tubulaires",
	"dialog.add_spline.sides_radial": "Segments d'Anneaux",
	"dialog.add_spline.radius": "Diamètre du Tube",
	"dialog.add_spline.length": "Longueur",
	"dialog.add_spline.width": "Largeur",
	"dialog.plugins.revoke_permissions": "Revoke Permissions",
	"dialog.expression_editor.pretty_print": "Pretty Print",
	"dialog.expression_editor.minify": "Minify",
	"dialog.expression_editor.find_replace": "Find/Replace",
	"dialog.create_gif.show_gizmos": "Record Gizmos & Grid",
	"dialog.preview_options.title": "Preview Options",
	"dialog.preview_options.background": "Background",
	"dialog.preview_options.background.checkerboard": "Checkerboard",
	"dialog.preview_options.background.solid": "Solid",
	"dialog.preview_options.background.custom_color": "Custom Color",
	"dialog.preview_options.show_gizmos": "Show Gizmos",
	"dialog.skin.texture_source": "Texture Source",
	"dialog.skin.texture_source.template": "Generate Template",
	"dialog.skin.texture_source.load_texture": "Load from Minecraft",
	"dialog.skin.texture_file": "Texture File",
	"dialog.convert_skin.adjust_texture": "Adjust Texture",
	"dialog.settings.clear_profile_value": "Clear profile value",
	"layout.section.customize": "Customize",
	"layout.theme.configure": "Configure",
	"layout.color.elevated": "Elevated",
	"layout.color.elevated.desc": "Elevated UI elements, usually separated by drop shadow",
	"layout.file.watch_changes": "Watch Changes and Reload",
	"settings.autocomplete_code": "Autocomplete Code",
	"settings.autocomplete_code.desc": "Display autocomplete suggestions in code editors",
	"settings.detect_flipbook_textures": "Detect Flipbook Textures",
	"settings.detect_flipbook_textures.desc": "Automatically detect flipbook animated textures and preview them as animation",
	"settings.double_click_select_reference": "Select Reference Image on Double Click",
	"settings.double_click_select_reference.desc": "Double click the viewport to select a reference image",
	"settings.default_keyframe_interpolation": "Default Keyframe Interpolation",
	"settings.default_keyframe_interpolation.desc": "Select the default keyframe interpolation mode",
	"settings.color_picker_style": "Color Picker Style",
	"settings.color_picker_style.desc": "Select the style of the paint mode color picker",
	"settings.export_asset_paths": "Export Asset Paths",
	"settings.export_asset_paths.desc": "Select how paths to assets such as textures or animations get saved in .bbmodel files",
	"settings.export_asset_paths.relative": "Relative Paths",
	"settings.export_asset_paths.absolute": "Full Paths",
	"settings.export_asset_paths.both": "Relative & Full Paths (Texture only)",
	"settings.export_asset_paths.none": "No Export",
	"action.slider_spline_resolution": "Résolution de la Courbe %0",
	"action.slider_spline_resolution.desc": "Changer la résolution de la courbe sur l'axe %0 (%1)",
	"action.slider_spline_resolution.u.desc_precision": "Segments d'Anneaux",
	"action.slider_spline_resolution.v.desc_precision": "Segments Tubulaires",
	"action.slider_spline_radius": "Diamètre de la courbe",
	"action.slider_spline_radius.desc": "Changer le diamètre de la courbe",
	"action.slider_spline_handle_tilt": "Roulis de la Poignée",
	"action.slider_spline_handle_tilt.desc": "Changer le roulis de la Poignée de Courbe",
	"action.slider_spline_handle_size": "Diamètre de la Poignée",
	"action.slider_spline_handle_size.desc": "Changer le diamètre de la poignée",
	"action.blend_mode.lighten": "Lighten",
	"action.blend_mode.darken": "Darken",
	"action.weight_brush": "Weight Brush",
	"action.weight_brush.desc": "Paint vertex weights on meshes for armature deformations",
	"action.convert_minecraft_skin_variant": "Convert Slim/Wide Skin",
	"action.convert_minecraft_skin_variant.desc": "Switch the skin model between the classic wide (steve) model and the slim (alex) model. Optionally auto-adjust the texture to fit the model",
	"action.custom_skin_poses": "Custom Skin Poses",
	"action.custom_skin_poses.desc": "Load a custom skin pose preset",
	"action.custom_skin_poses.update": "Update Pose",
	"action.custom_skin_poses.update.desc": "Overwrite the saved pose with the current pose of the model",
	"action.add_custom_skin_pose": "Add Custom Skin Pose",
	"action.add_custom_skin_pose.desc": "Save the current pose of the model as a pose preset",
	"action.export_stl": "Export STL",
	"action.export_stl.desc": "Export a STL model for 3D printing",
	"action.add_element": "Add Element",
	"action.add_element.desc": "Add a new element from the list of element types",
	"action.add_spline": "Créer une Courbe",
	"action.add_spline.desc": "Créer une nouvelle Courbe",
	"action.add_billboard": "Add Billboard",
	"action.add_billboard.desc": "Adds a new billboard, a flat element that always faces towards the camera",
	"action.add_armature": "Add Armature",
	"action.add_armature.desc": "Adds an armature that allows deforming a mesh via animation",
	"action.add_armature_bone": "Add Armature Bone",
	"action.add_armature_bone.desc": "Adds a bone to the armature",
	"action.search_textures": "Search Textures",
	"action.search_textures.desc": "Search for textures by name",
	"action.search_animations": "Search Animations",
	"action.search_animations.desc": "Search for animations by name",
	"action.spline_selection_mode": "Mode de sélection des Courbes",
	"action.spline_selection_mode.object": "Objet",
	"action.spline_selection_mode.handles": "Poignées",
	"action.spline_render_mode": "Géométrie",
	"action.spline_render_mode.mesh": "Tube",
	"action.spline_render_mode.path": "Ligne",
	"action.spline_render_mode.desc": "Quelle genre de géométrie cette courbe devrait rendre.",
	"action.spline_uv_mode": "Type d'UV",
	"action.spline_uv_mode.length_accurate": "Correspondant à la longueur",
	"action.spline_uv_mode.uniform": "Uniforme",
	"action.spline_uv_mode.per_segment": "Par Segment",
	"action.spline_uv_mode.desc": "Comment les UV du tube de cette courbe sont dépliés.",
	"action.spline_ring_segments": "Segments d'Anneaux",
	"action.spline_ring_segments.desc": "Combien de divisions chaque Anneau du Tube de cette Courbe possède.",
	"action.spline_tube_segments": "Segment Tubulaires",
	"action.spline_tube_segments.desc": "Combien de divisions cette Courbe possède sur sa longueur.",
	"action.spline_tube_radius": "Diamètre du Tube",
	"action.spline_tube_radius.desc": "Définir le diamètre du Tube de cette Courbe.",
	"action.spline_display_space": "Afficher les axes",
	"action.spline_display_space.desc": "Affiche les axes spatiaux le long de la Courbe.",
	"action.spline_handle_mode": "Mode de poignée",
	"action.spline_handle_mode.desc": "Comment les Poignées de cette Courbe devrait se comporter.",
	"action.spline_handle_mode.aligned": "Alignée",
	"action.spline_handle_mode.free": "Libre",
	"action.spline_handle_mode.mirrored": "En Mirroir",
	"action.slider_weight_brush_size": "Weight Brush Size",
	"action.weight_brush_xray": "Weight Brush XRay Mode",
	"action.weight_brush_xray.desc": "When enabled, the weight brush will affect all vertices instead of just the ones that are visible on the surface",
	"action.apply_spline_rotation": "Appliqué l'orientation",
	"action.apply_spline_rotation.desc": "Réinitialise l'orientation de cette Courbe, et l'applique à la géométrie à la place.",
	"action.extrude_spline_selection": "Extrusion sur la séléction",
	"action.extrude_spline_selection.desc": "Fait une extrusion a partir des Poignées sélectionnées sur toutes les Courbes.",
	"action.split_spline": "Scindé la Courbe",
	"action.split_spline.desc": "Coupe la courbe en deux objets à partir de la Poignée sélectionnée.",
	"action.divide_spline_curve": "Diviser le segment",
	"action.divide_spline_curve.desc": "Divise le segment sélectionné en deux, et créer une nouvelle poignée au point d'intersection.",
	"action.set_vertex_weights": "Set Vertex Weights",
	"action.set_vertex_weights.desc": "Set the vertex weights of the selected vertices to a specific value on a certain armature bone",
	"action.calculate_vertex_weights": "Calculate Vertex Weights",
	"action.calculate_vertex_weights.desc": "Automatically assign vertex weights weights based on the position of the bones",
	"action.shelf_alignment": "Shelf Alignment",
	"action.shelf_alignment.desc": "Select the vertical alignment of items on the shelf",
	"action.shelf_alignment.top": "Top Alignment",
	"action.shelf_alignment.bottom": "Bottom Alignment",
	"action.view_mode.vertex_weight": "Vertex Weight",
	"action.view_mode.weighted_bone_colors": "Vertex Bone Colors",
	"action.create_animation_group": "Create Animation Group",
	"action.create_animation_group.desc": "Create a group of animations",
	"action.move_graph_keyframes_up": "Move Keyframe Graph Up",
	"action.move_graph_keyframes_down": "Move Keyframe Graph Down",
	"menu.skin": "Skin",
	"menu.text_edit.expression_editor": "Expression Editor",
	"menu.color_picker.picker_type.normal": "Normal Map",
	"menu.texture.flipbook_animation": "Flipbook Animation",
	"menu.panel.attach_to": "Attach To",
	"menu.animation.playing": "Playing",
	"menu.animation_file.save_as": "Save As",
	"menu.animator.quaternion_interpolation": "Quaternion Interpolation",
	"edit.extrude_spline_selection.extend": "Etendre",
	"edit.divide_spline_curve.position": "Position",
	"group.bedrock_binding": "Binding",
	"group.cem_attach": "CEM Attach",
	"group.cem_model": "CEM Model",
	"group.cem_scale": "CEM Scale",
	"cube.rescale": "Rotation Rescale",
	"cube.rescale.desc": "Rescale cube to compensate for the rotation angle",
	"mesh.shading": "Shading",
	"mesh.shading.flat": "Flat",
	"mesh.shading.smooth": "Smooth",
	"spline_mesh.cyclic": "Cyclique",
	"spline_mesh.cyclic.desc": "Définis si cette courbe devrait être fermée ou non (Cercle ou Ligne)",
	"billboard.offset": "Offset",
	"billboard.facing_mode": "Facing Mode",
	"billboard.facing_mode.lookat": "Look At",
	"billboard.facing_mode.lookat_y": "Look At Y",
	"billboard.facing_mode.rotate": "Rotate",
	"billboard.facing_mode.rotate_y": "Rotate Y",
	"armature_bone.connected": "Connected",
	"reference_image.blueprint": "Locked Blueprint",
	"codec.image.alpha_channel": "Alpha Channel",
	"codec.image.animation_fps": "Animation FPS",
	"panel.palette": "Palette",
	"panel.keyframe.change_effect_file": "Change Effect File",
	"panel.transform": "Transform",
	"panel.element.spline_dimensions": "Dimensions de la Courbe",
	"display.slot.on_shelf": "Shelf",
	"display.reference.shelf": "Shelf (All Slots)",
	"display.reference.shelf_left": "Shelf (Left Slot)",
	"display.reference.shelf_center": "Shelf (Center Slot)",
	"display.reference.shelf_right": "Shelf (Right Slot)",
	"message.newer_project_format_version.title": "Outdated client",
	"message.newer_project_format_version.message": "This file was saved in a newer version of Blockbench. Update to Blockbench %0 or newer to be able to open it correctly",
	"message.load_images.add_layer": "Add as Layer",
	"message.load_images.category.add_to_project": "Add to project",
	"message.load_images.category.new_project": "New project",
	"message.load_palette.title": "Load Palette",
	"message.load_palette.message": "Are you sure you want to load this palette? This will replace your current color palette.",
	"dialog.set_vertex_weights.weight": "Weight",
	"dialog.set_vertex_weights.overwrite": "Overwrite other bones",
	"action.element_render_order.short": "Render Order",
	"action.element_render_order.desc": "Render order of elements. This can help fix elements that are hidden behind other elements with transparent textures. Leave it on Auto for opaque elements.",
	"spline.shading.flat": "Plat",
	"spline.shading.smooth": "Lisse",
	"spline.shading": "Rendu",
	"spline.shading.desc": "Comment le tube de cette Courbe devrait être rendu.",
	"action.slider_weight_brush_limit": "Weight Brush Limit",
	"action.slider_weight_brush_limit.desc": "Set an upper limit for how much weight the weight brush can assign to a vertex",
	"action.weight_brush_blend_mode": "Weight Brush Blend Mode",
	"action.weight_brush_blend_mode.set": "Set",
	"action.weight_brush_blend_mode.add": "Add",
	"action.apply_texture_to_elements": "Apply Texture to Elements",
	"action.apply_texture_to_elements.desc": "Apply the selected texture to the selected elements",
	"menu.panel.reset_size": "Reset Size",
	"action.import_layer": "Import Layer",
	"action.import_layer.desc": "Import image files as layers",
	"menu.collection.open_file": "Open File",
	"layout.version": "Version",
	"settings.status_bar_transform_sliders": "Transform Sliders in Status Bar",
	"settings.status_bar_transform_sliders.desc": "Display the transform sliders toolbar of the selected tool in the status bar instead of using the Transform panel",
	"settings.default_bedrock_format": "Default Bedrock Format",
	"settings.default_bedrock_format.desc": "Select the default format to load Minecraft Bedrock models in, when no specific format can be detected from context.",
	"settings.limit_brush_opacity_per_stroke": "Limit Brush Opacity per Stroke",
	"settings.limit_brush_opacity_per_stroke.desc": "Limit the opacity that a brush can apply to the value of the opacity slider during each brush stroke. With a smooth brush this behavior can potentially lead to slight unwanted noise.",
	"action.merge_splines": "Merge Splines",
	"action.merge_splines.desc": "Merge multiple splines into one",
	"settings.default_java_block_version": "Default Java Block/Item Version",
	"settings.default_java_block_version.desc": "Default format version when creating new Java block/item models or opening files without format version",
	"data.bounding_box": "Bounding Box",
	"keys.option": "Option",
	"keys.slide_lmb_horizontal": "Left-click slide horizontal",
	"keys.slide_lmb_vertical": "Left-click slide vertical",
	"keys.slide_rmb_horizontal": "Right-click slide horizontal",
	"keys.slide_rmb_vertical": "Right-click slide vertical",
	"message.recover_backup.unknown_project": "Unknown project",
	"message.recover_backup.discard_others": "Discard all others",
	"message.unsupported_file_extension.title": "File format not supported",
	"message.unsupported_file_extension.message": "Cannot open file %0, the format is not supported. You might need a plugin for this file type.",
	"message.unsupported_file_extension.open_in_default_program": "Open in default program",
	"dialog.project.uv_size": "UV Size",
	"dialog.collection.offset": "Offset",
	"dialog.texture.fps": "FPS",
	"dialog.texture.fps.desc": "Frames per second of the texture flipbook animation",
	"dialog.edit_uv_size.title": "Edit UV Size",
	"dialog.edit_uv_size.target": "Target",
	"dialog.edit_uv_size.adjust": "Adjust",
	"dialog.edit_uv_size.adjust.adjust_uv": "Counter UV",
	"dialog.edit_uv_size.adjust.adjust_scale": "Counter UV & Scale",
	"dialog.edit_uv_size.adjust.keep": "Keep UV",
	"dialog.edit_uv_size.target_size": "Target UV Size",
	"dialog.edit_uv_size.preset.original": "Original",
	"dialog.edit_uv_size.preset.match_texture": "Match Texture",
	"dialog.edit_uv_size.result": "Result",
	"dialog.edit_uv_size.result.textures": "Textures",
	"dialog.adjust_brightness_contrast.brightness": "Brightness",
	"dialog.adjust_brightness_contrast.contrast": "Contrast",
	"dialog.adjust_saturation_hue.saturation": "Saturation",
	"dialog.adjust_saturation_hue.hue": "Hue",
	"dialog.adjust_opacity.mode": "Mode",
	"dialog.adjust_opacity.mode.multiply": "Multiply",
	"dialog.adjust_opacity.mode.set": "Set",
	"dialog.bedrock_bounding_box.type": "Type",
	"dialog.bedrock_bounding_box.type.collision_box": "Collision",
	"dialog.bedrock_bounding_box.type.selection_box": "Selection Box",
	"dialog.bedrock_bounding_box.type.hitbox": "Hitbox",
	"dialog.bedrock_bounding_box.hitbox_note": "Please note that entity hitboxes only work up to a certain size and may not adapt to the rotation of the entity in-game.",
	"dialog.bedrock_bounding_box.collision_note": "Please note that entity collision boxes only support one centered shape with a square top profile.",
	"dialog.bedrock_bounding_box.no_bounding_boxes": "No bounding boxes exist in this project",
	"dialog.install_plugins_from_list.ids": "Plugin IDs",
	"dialog.install_plugins_from_list.info": "Install several plugins from a list of IDs. Before installing, please ensure that you actually need all plugins. Keeping inactive plugins can increase the risk of bugs and incompatibilities with future updates.",
	"dialog.copy_installed_plugins.details": "Include Details",
	"dialog.flip_animation.phase_offset": "Phase Offset",
	"dialog.flip_animation.phase_offset.off": "Off",
	"dialog.flip_animation.phase_offset.custom": "Custom",
	"dialog.flip_animation.clear_opposite": "Overwrite opposite",
	"settings.flipbook_textures_in_animation": "Play Flipbook Textures in Animation",
	"settings.flipbook_textures_in_animation.desc": "Preview animations on flipbook textures in sync with the animation timeline",
	"settings.display_uv": "Display UV Faces",
	"settings.display_uv.desc": "Select which UV faces are displayed in the UV editor",
	"settings.display_uv.selected_faces": "Only selected faces",
	"settings.display_uv.selected_elements": "All faces on selected elements",
	"settings.display_uv.all_elements": "All faces on all elements",
	"settings.local_position_values": "Local Position Values",
	"settings.local_position_values.desc": "Display all position values in the Transform panel in local space",
	"settings.transform_cube_from_center": "Transform Cubes from Center",
	"settings.transform_cube_from_center.desc": "Edit the cube position values from the center instead of the corner",
	"settings.color_picker_tool_switch": "Color Picker Tool Switch",
	"settings.color_picker_tool_switch.desc": "When picking a transparent pixel, switch to the eraser. When the eraser was previously selected and a color is picked, switch to the brush",
	"keybind.preview_scroll_zoom": "Zoom View",
	"keybind.uv_editor_scroll_zoom": "Zoom UV/2D Editor",
	"action.blend_mode.alpha_mask": "Alpha Mask",
	"action.swap_tools.hold": "Hold to swap (Color Picker)",
	"action.import_bedrock_voxel_shape": "Import Bedrock Voxel Shape",
	"action.import_bedrock_voxel_shape.desc": "Add a voxel shape from a json file to the current project",
	"action.export_bedrock_voxel_shape": "Export Bedrock Voxel Shape",
	"action.export_bedrock_voxel_shape.desc": "Export the bounding boxes in the project as a bedrock voxel shape file",
	"action.plugins_window_menu": "Menu",
	"action.copy_installed_plugins": "Copy Installed Plugins",
	"action.copy_installed_plugins.desc": "Generate and copy a list of the currently installed plugins",
	"action.install_plugins_from_list": "Install Plugins from List",
	"action.install_plugins_from_list.desc": "Install plugins from a list of plugin IDs",
	"action.add_bounding_box": "Add Bounding Box",
	"action.add_bounding_box.desc": "Adds a new bounding box",
	"action.split_alpha_into_layer": "Split Alpha Channel into Layer",
	"action.split_alpha_into_layer.desc": "Split the alpha channel of the texture into an alpha mask layer",
	"action.generate_bedrock_block_box": "Copy Collision/Selection Component",
	"action.generate_bedrock_block_box.desc": "Generate a collision or selection box component for Minecraft Bedrock Edition blocks",
	"action.generate_bedrock_entity_box": "Copy Collision/Hitbox Component",
	"action.generate_bedrock_entity_box.desc": "Generate a collision or custom hit test component for Minecraft Bedrock Edition entities",
	"action.refresh_texture": "Refresh Texture",
	"action.refresh_texture.desc": "Reload the texture from file",
	"action.move_uv_to_cursor": "Move UV to Cursor",
	"action.move_uv_to_cursor.desc": "Move the selected UV faces to the mouse cursor position",
	"action.edit_mode_uv_overlay": "Display All Elements",
	"action.round_keyframe_values": "Round Keyframe Values",
	"action.round_keyframe_values.desc": "Round all values of the selected keyframes",
	"action.keyframe_column_create.all_channels": "All Channels",
	"action.keyframe_column_create.all_channels.desc": "Initialize all channels with keyframes even if they had no keyframes previously",
	"action.add_all_to_timeline": "Add All to Timeline",
	"action.mirror_animating": "Mirror Animating",
	"action.mirror_animating.desc": "Mirror animation edits to the opposite side",
	"action.copy_animation_pose": "Copy Animation Pose",
	"action.copy_animation_pose.desc": "Copy all keyframes to replicate the current animation pose",
	"menu.texture.file_format": "File Format",
	"menu.texture.wrap_mode": "Wrap Mode",
	"menu.texture.wrap_mode.limited": "Restricted",
	"menu.texture.wrap_mode.repeat": "Repeat",
	"menu.texture.wrap_mode.clamp": "Clamp Edge",
	"edit.reparent_selection.adjust_position": "Preserve World Transform",
	"texture_mesh.texture_name": "Texture Name",
	"display.slot.embedded": "Embedded",
	"display.animate_preview": "Preview Animation",
	"display.reference.flower_pot": "Flower Pot"
}